export default {
  "type": "category",
  "link": "http://www.newson6.com/category/112042/news",
  "id": 112042,
  "status": "Live",
  "owner": {
    "id": 691,
    "name": "KOTV",
    "baseurl": "www.newson6.com",
    "enablecommentsonshare": false
  },
  "build": {
    "machinename": "NJTASKRUN02",
    "dateTime": "2018-05-23T20:34:55Z"
  },
  "iscontrolledcategory": false,
  "isHomeCategory": false,
  "headline": "News",
  "ads": [{
    "type": "ad",
    "sz": "wnsz_23",
    "show": true
  }, {
    "type": "ad",
    "sz": "wnsz_45",
    "show": true
  }],
  "implicitcontent": {
    "show": true
  },
  "abstract": "",
  "mobile": "",
  "contentClassification": "News",
  "cls": 3,
  "creationDate": "2007-09-20T20:22:32Z",
  "datetime": {
    "created": "2007-09-20T16:22:32.0000000",
    "lastedited": "2013-12-18T10:51:36.0000000"
  },
  "abridged": {
    "headline": "News",
    "isclickable": true
  },
  "seo": {
    "browsertitle": "News:Leading source for breaking news & developing stories",
    "keywords": "Tulsa news,crime tracker,Oklahoma breaking news,oklahoma news,video,Tulsa tv,school closings, kotv news,expanded coverage,kotv links,channel 6,oklahoma headlines,cbs news, Scott Thompson,Terry Hood",
    "description": "NewsOn6.com is your leading source for breaking news, developing stories, local weather, Oklahoma sports and live streaming video.",
    "robot": "Index,Follow,NoArchive",
    "pageurl": "news"
  },
  "totalresults": "43",
  "features": [{
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38329334/osbi-91-year-old-man-hospitalized-after-hulbert-home-invasion",
    "id": 38329334,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T17:01:04Z"
    },
    "headline": "TPD Searching for Latino Man Who Abandonded Pregnant Woman Downtown, who Later Died",
    "abstract": "<p>The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "TPD Searching for Latino Man Who Abandonded Dying Pregnant Woman Downtown",
      "isclickable": true,
      "abstract": "<p>The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.</p>",
      "abstractimage": {
        "filename": "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fcbsnews3.cbsistatic.com%2Fhub%2Fi%2Fr%2F2010%2F03%2F15%2F91adf94d-1c4f-11e3-9918-005056850598%2Fthumbnail%2F620x350%2Ff8b8583d03d3faceebbd592b8b058118%2Fcrime_pregnant_generic.jpg%23&amp;f=1",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T17:00:51.0000000"
      }
    },
    "abstractimage": {
      "filename": "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fcbsnews3.cbsistatic.com%2Fhub%2Fi%2Fr%2F2010%2F03%2F15%2F91adf94d-1c4f-11e3-9918-005056850598%2Fthumbnail%2F620x350%2Ff8b8583d03d3faceebbd592b8b058118%2Fcrime_pregnant_generic.jpg%23&amp;f=1",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T17:00:51.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T21:01:03Z",
    "lastEditedDate": "2018-06-01T21:01:03Z",
    "publishedDate": "2018-06-01T21:01:03Z",
    "updatedDate": "2018-06-01T21:01:03Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T17:01:03.0000000",
      "lastedited": "2018-06-01T17:01:03.0000000",
      "published": "2018-06-01T17:01:03.0000000",
      "updated": "2018-06-01T17:01:03.0000000"
    },
    "seo": {
      "description": "The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.",
      "pageurl": "osbi-91-year-old-man-hospitalized-after-hulbert-home-invasion",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "HULBERT, Oklahoma"
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38329031/checotah-police-ask-for-help-identifying-suspected-shoplifter",
    "id": 38329031,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T16:31:28Z"
    },
    "headline": "Checotah Police Ask For Help Identifying Suspected Shoplifter",
    "abstract": "<p>Checotah police are looking for a man they say is suspected of shoplifting on multiple occasions.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Checotah Police Ask For Help Identifying Suspected Shoplifter",
      "isclickable": true,
      "abstract": "<p>Checotah police are looking for a man they say is suspected of shoplifting on multiple occasions.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16892630_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T16:24:54.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16892630_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T16:24:54.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T20:31:28Z",
    "lastEditedDate": "2018-06-01T20:31:28Z",
    "publishedDate": "2018-06-01T20:31:28Z",
    "updatedDate": "2018-06-01T20:31:28Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T16:31:28.0000000",
      "lastedited": "2018-06-01T16:31:28.0000000",
      "published": "2018-06-01T16:31:28.0000000",
      "updated": "2018-06-01T16:31:28.0000000"
    },
    "seo": {
      "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, Crime",
      "description": "Checotah police are looking for a man they say is suspected of shoplifting on multiple occasions.",
      "pageurl": "checotah-police-ask-for-help-identifying-suspected-shoplifter",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "CHECOTAH, Oklahoma",
    "topics": [{
      "type": "topic",
      "value": "Crime"
    }]
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38328351/trump-says-june-12-singapore-summit-is-on",
    "id": 38328351,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS06",
      "dateTime": "2018-06-01T15:26:41Z"
    },
    "headline": "Trump Says June 12 Singapore Summit Is On",
    "abstract": "<p>President Trump said the June 12th summit in Singapore with North Korea is happening, after meeting with top North Korean official Kim Yong Chol for more than an hour in the Oval Office.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Trump Says June 12 Singapore Summit Is On",
      "isclickable": true,
      "abstract": "<p>President Trump said the June 12th summit in Singapore with North Korea is happening, after meeting with top North Korean official Kim Yong Chol for more than an hour in the Oval Office.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16892040_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T14:54:31.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16892040_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T14:54:31.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T18:55:04Z",
    "lastEditedDate": "2018-06-01T19:17:35Z",
    "publishedDate": "2018-06-01T18:55:04Z",
    "updatedDate": "2018-06-01T19:17:35Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T14:55:04.0000000",
      "lastedited": "2018-06-01T15:17:35.0000000",
      "published": "2018-06-01T14:55:04.0000000",
      "updated": "2018-06-01T15:17:35.0000000"
    },
    "seo": {
      "description": "President Trump said the June 12th summit in Singapore with North Korea is happening, after meeting with top North Korean official Kim Yong Chol for more than an hour in the Oval Office.",
      "pageurl": "trump-says-june-12-singapore-summit-is-on",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "CBS",
      "lastname": "News",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "WASHINGTON, D.C."
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38327590/tps-budget-developed-with-state-funded-teacher-pay-raise-in-mind",
    "id": 38327590,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN02",
      "dateTime": "2018-06-01T13:27:25Z"
    },
    "headline": "TPS Budget Developed With State-Funded Teacher Pay Raise In Mind",
    "abstract": "<p>Tulsa Public Schools says their budget is being developed on the assumption that teacher pay raises will be fully funded by the state.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "TPS Budget Developed With State-Funded Teacher Pay Raise In Mind",
      "isclickable": true,
      "abstract": "<p>Tulsa Public Schools says their budget is being developed on the assumption that teacher pay raises will be fully funded by the state.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16891401_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T13:23:49.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16891401_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T13:23:49.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T17:27:25Z",
    "lastEditedDate": "2018-06-01T17:27:25Z",
    "publishedDate": "2018-06-01T17:27:25Z",
    "updatedDate": "2018-06-01T17:27:25Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T13:27:25.0000000",
      "lastedited": "2018-06-01T13:27:25.0000000",
      "published": "2018-06-01T13:27:25.0000000",
      "updated": "2018-06-01T13:27:25.0000000"
    },
    "seo": {
      "browsertitle": "TPS Budget Developed With State-Funded Teacher Pay Raise In Mind",
      "description": "Tulsa Public Schools says their budget is being developed on the assumption that teacher pay raises will be fully funded by the state.",
      "pageurl": "tps-budget-developed-with-state-funded-teacher-pay-raise-in-mind",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma",
    "topics": [{
      "type": "topic",
      "value": "news"
    }]
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38324202/tulsa-street-renamed-friday-ahead-of-tulsa-pride-week",
    "id": 38324202,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN03",
      "dateTime": "2018-06-01T14:12:14Z"
    },
    "headline": "Tulsa Street Renamed Ahead Of Tulsa Pride Weekend",
    "abstract": "<p>Tulsa's Pride weekend starts Friday morning and several blocks of a downtown street are being renamed in honor of the event.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Tulsa Street Renamed Ahead Of Tulsa Pride Weekend",
      "isclickable": true,
      "abstract": "<p>Tulsa's Pride weekend starts Friday morning and several blocks of a downtown street are being renamed in honor of the event.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16888190_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T05:54:17.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16888190_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T05:54:17.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T09:57:39Z",
    "lastEditedDate": "2018-06-01T17:27:19Z",
    "publishedDate": "2018-06-01T10:02:18Z",
    "updatedDate": "2018-06-01T17:27:19Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T05:57:39.0000000",
      "lastedited": "2018-06-01T13:27:19.0000000",
      "published": "2018-06-01T06:02:18.0000000",
      "updated": "2018-06-01T13:27:19.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14391406,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T18:12:14.483Z"
    }],
    "seo": {
      "description": "Tulsa's Pride weekend starts Friday morning and several blocks of a downtown street are being renamed in honor of the event.",
      "pageurl": "tulsa-street-renamed-friday-ahead-of-tulsa-pride-week",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Joseph",
      "lastname": "Holloway",
      "title": "News On 6",
      "link": "/story/32240686/joseph-holloway",
      "emailaddress": "richard.clark@newson6.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/JHollowayNews",
        "twitter": "a_cupof_JOE"
      }
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38326249/police-identify-sand-springs-homicide-victim",
    "id": 38326249,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS09",
      "dateTime": "2018-06-01T13:14:42Z"
    },
    "headline": "Police Identify Sand Springs Homicide Victim",
    "abstract": "<p>Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.&nbsp;&nbsp;</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Police Identify Sand Springs Homicide Victim",
      "isclickable": true,
      "abstract": "<p>Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.&nbsp;&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16890203_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T10:47:48.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16890203_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T10:47:48.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T14:49:15Z",
    "lastEditedDate": "2018-06-01T17:07:48Z",
    "publishedDate": "2018-06-01T14:49:15Z",
    "updatedDate": "2018-06-01T17:07:48Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T10:49:15.0000000",
      "lastedited": "2018-06-01T13:07:48.0000000",
      "published": "2018-06-01T10:49:15.0000000",
      "updated": "2018-06-01T13:07:48.0000000"
    },
    "seo": {
      "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, Crime",
      "description": "Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.  ",
      "pageurl": "police-identify-sand-springs-homicide-victim",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "SAND SPRINGS, Oklahoma",
    "topics": [{
      "type": "topic",
      "value": "Crime"
    }]
  }, {
    "displaysize": "-20",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38326894/remains-of-ok-wwii-veteran-being-returned-to-family",
    "id": 38326894,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS08",
      "dateTime": "2018-06-01T12:18:16Z"
    },
    "headline": "Remains Of OK WWII Veteran Being Returned To Family",
    "abstract": "<p>The remains of an Oklahoma serviceman killed in World War II have been accounted for and are being returned to his family.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Remains Of OK WWII Veteran Being Returned To Family",
      "isclickable": true,
      "abstract": "<p>The remains of an Oklahoma serviceman killed in World War II have been accounted for and are being returned to his family.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16890790_G.jpg",
        "width": 115,
        "location": "LEFT",
        "caption": "Image of Army Pfc. Oscar Sappington. [Defense POW/MIA Accounting Agency]",
        "lastediteddate": "2018-06-01T12:06:23.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16890790_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T12:06:23.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T16:06:55Z",
    "lastEditedDate": "2018-06-01T16:14:42Z",
    "publishedDate": "2018-06-01T16:06:55Z",
    "updatedDate": "2018-06-01T16:14:42Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T12:06:55.0000000",
      "lastedited": "2018-06-01T12:14:42.0000000",
      "published": "2018-06-01T12:06:55.0000000",
      "updated": "2018-06-01T12:14:42.0000000"
    },
    "seo": {
      "description": "The remains of an Oklahoma serviceman killed in World War II have been accounted for and are being returned to his family.",
      "pageurl": "remains-of-ok-wwii-veteran-being-returned-to-family",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38329414/me-okc-couple-strangled-before-being-discovered-in-mcintosh-county",
    "id": 38329414,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN04",
      "dateTime": "2018-06-01T17:10:42Z"
    },
    "headline": "ME: OKC Couple Strangled Before Being Discovered In McIntosh County",
    "abstract": "<p>As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "ME: OKC Couple Strangled Before Being Discovered In McIntosh County",
      "isclickable": true,
      "abstract": "<p>As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16892982_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T17:09:46.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16892982_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T17:09:46.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T21:10:42Z",
    "lastEditedDate": "2018-06-01T21:10:41Z",
    "publishedDate": "2018-06-01T21:10:42Z",
    "updatedDate": "2018-06-01T21:10:42Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T17:10:42.0000000",
      "lastedited": "2018-06-01T17:10:41.0000000",
      "published": "2018-06-01T17:10:42.0000000",
      "updated": "2018-06-01T17:10:42.0000000"
    },
    "seo": {
      "browsertitle": "ME: OKC Couple Strangled Before Being Discovered In McIntosh Cou",
      "description": "As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.",
      "pageurl": "me-okc-couple-strangled-before-being-discovered-in-mcintosh-county",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "McINTOSH COUNTY, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38325736/okmulgee-county-jail-escapee-sought",
    "id": 38325736,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS18",
      "dateTime": "2018-06-01T15:08:54Z"
    },
    "headline": "Rape Suspect Escapes From Okmulgee County Jail",
    "abstract": "<p>Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.&nbsp;&nbsp;The sheriff's office says it not known if Coleman is armed, but he is&nbsp;considered to be dangerous.&nbsp;&nbsp; If seen, you are asked to call the sheriff's office at 918-756-0251.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Rape Suspect Escapes From Okmulgee County Jail",
      "isclickable": true,
      "abstract": "<p>Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.&nbsp;&nbsp;The sheriff's office says it not known if Coleman is armed, but he is&nbsp;considered to be dangerous.&nbsp;&nbsp; If seen, you are asked to call the sheriff's office at 918-756-0251.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16889690_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T09:44:12.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16889690_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T09:44:12.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T13:44:23Z",
    "lastEditedDate": "2018-06-01T19:04:30Z",
    "publishedDate": "2018-06-01T13:44:23Z",
    "updatedDate": "2018-06-01T19:04:30Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T09:44:23.0000000",
      "lastedited": "2018-06-01T15:04:30.0000000",
      "published": "2018-06-01T09:44:23.0000000",
      "updated": "2018-06-01T15:04:30.0000000"
    },
    "seo": {
      "description": "Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.  The sheriff's office says it not known if C...",
      "pageurl": "okmulgee-county-jail-escapee-sought",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "OKMULGEE, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38326746/overnight-search-leads-to-drug-bust-in-cherokee-county-kansas",
    "id": 38326746,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN04",
      "dateTime": "2018-06-01T11:48:26Z"
    },
    "headline": "Overnight Search Leads To Drug Bust In Cherokee County, Kansas",
    "abstract": "<p>A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night.&nbsp;</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Overnight Search Leads To Drug Bust In Cherokee County, Kansas",
      "isclickable": true,
      "abstract": "<p>A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16890668_G.jpg",
        "width": 115,
        "location": "LEFT",
        "caption": "Mug shot of Jeremey Manders.",
        "lastediteddate": "2018-06-01T11:45:15.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16890668_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T11:45:15.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T15:48:25Z",
    "lastEditedDate": "2018-06-01T15:48:25Z",
    "publishedDate": "2018-06-01T15:48:25Z",
    "updatedDate": "2018-06-01T15:48:25Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T11:48:25.0000000",
      "lastedited": "2018-06-01T11:48:25.0000000",
      "published": "2018-06-01T11:48:25.0000000",
      "updated": "2018-06-01T11:48:25.0000000"
    },
    "seo": {
      "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, Crime",
      "description": "A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night. ",
      "pageurl": "overnight-search-leads-to-drug-bust-in-cherokee-county-kansas",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "CHEROKEE COUNTY, Kansas",
    "topics": [{
      "type": "topic",
      "value": "Crime"
    }]
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38325897/jana-jae-talks-about-american-heritage-festival-on-6-in-the-morning",
    "id": 38325897,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T10:40:48Z"
    },
    "headline": "Jana Jae Talks About American Heritage Festival On 6 In The Morning",
    "abstract": "<p>Grand Lake Festivals is gearing up for the 21st annual American Heritage Festival in Grove&nbsp;June 7th through the 9th.&nbsp;&nbsp;&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Jana Jae Talks About American Heritage Festival On 6 In The Morning",
      "isclickable": true,
      "abstract": "<p>Grand Lake Festivals is gearing up for the 21st annual American Heritage Festival in Grove&nbsp;June 7th through the 9th.&nbsp;&nbsp;&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16889846_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T10:13:28.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16889846_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T10:13:28.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T14:14:31Z",
    "lastEditedDate": "2018-06-01T14:40:47Z",
    "publishedDate": "2018-06-01T14:40:47Z",
    "updatedDate": "2018-06-01T14:40:47Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T10:14:31.0000000",
      "lastedited": "2018-06-01T10:40:47.0000000",
      "published": "2018-06-01T10:40:47.0000000",
      "updated": "2018-06-01T10:40:47.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14391017,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T14:37:26.360Z"
    }],
    "seo": {
      "browsertitle": "Jana Jae Talks About American Heritage Festival On 6 In The Morn",
      "description": "Grand Lake Festivals is gearing up for the 21st annual American Heritage Festival in Grove June 7th through the 9th.  ",
      "pageurl": "jana-jae-talks-about-american-heritage-festival-on-6-in-the-morning",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38324884/massive-gator-gar-caught-on-lake-texoma",
    "id": 38324884,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T10:00:17Z"
    },
    "headline": "Massive Gator Gar Caught On Lake Texoma",
    "abstract": "<p>An Oklahoma man was in for quite the surprise when he recently went fishing at Lake Texoma near the town of McBride. Oklahoma Game Wardens shared a photo of Tim Butler's catch on Facebook.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Massive Gator Gar Caught On Lake Texoma",
      "isclickable": true,
      "abstract": "<p>An Oklahoma man was in for quite the surprise when he recently went fishing at Lake Texoma near the town of McBride. Oklahoma Game Wardens shared a photo of Tim Butler's catch on Facebook.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16888916_G.jpg",
        "width": 115,
        "location": "LEFT",
        "caption": "Oklahoma Game Warden Facebook photo",
        "lastediteddate": "2018-06-01T07:54:52.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16888916_G.jpg",
      "width": 250,
      "location": "LEFT",
      "caption": "Oklahoma Game Warden Facebook photo",
      "lastediteddate": "2018-06-01T07:54:52.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T11:55:47Z",
    "lastEditedDate": "2018-06-01T14:00:16Z",
    "publishedDate": "2018-06-01T13:21:01Z",
    "updatedDate": "2018-06-01T14:00:16Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T07:55:47.0000000",
      "lastedited": "2018-06-01T10:00:16.0000000",
      "published": "2018-06-01T09:21:01.0000000",
      "updated": "2018-06-01T10:00:16.0000000"
    },
    "seo": {
      "description": "An Oklahoma man was in for quite the surprise when he recently went fishing at Lake Texoma near the town of McBride.",
      "pageurl": "massive-gator-gar-caught-on-lake-texoma",
      "shorturl": "http://bit.ly/2snocBq",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "LAKE TEXOMA"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38324174/police-two-arrested-at-tulsa-quiktrip-on-kidnapping-robbery-complaints",
    "id": 38324174,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS09",
      "dateTime": "2018-06-01T09:09:34Z"
    },
    "headline": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
    "abstract": "<p>Police arrest two men Thursday evening after officers say the pair held and robbed another&nbsp;man in his own car outside a Tulsa QuikTrip.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
      "isclickable": true,
      "abstract": "<p>Police arrest two men Thursday evening after officers say the pair held and robbed another&nbsp;man in his own car outside a Tulsa QuikTrip.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16889094_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T08:16:33.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16889094_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T08:16:33.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T09:42:46Z",
    "lastEditedDate": "2018-06-01T13:01:31Z",
    "publishedDate": "2018-06-01T10:02:19Z",
    "updatedDate": "2018-06-01T13:01:31Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T05:42:46.0000000",
      "lastedited": "2018-06-01T09:01:31.0000000",
      "published": "2018-06-01T06:02:19.0000000",
      "updated": "2018-06-01T09:01:31.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390450,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T10:04:23.130Z"
    }],
    "seo": {
      "browsertitle": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
      "description": "Police arrest two men Thursday evening after officers say the pair held and robbed another man in his own car outside a Tulsa QuikTrip.",
      "pageurl": "police-two-arrested-at-tulsa-quiktrip-on-kidnapping-robbery-complaints",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323988/no-oklahoma-stores-in-latest-sears-closing-announcement",
    "id": 38323988,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS07",
      "dateTime": "2018-06-01T07:46:13Z"
    },
    "headline": "No Oklahoma Stores In Latest Sears Closing Announcement",
    "abstract": "<p>Sears is closing an additional 72 stores this year, according to the retailer.&nbsp; None are in Oklahoma.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "No Oklahoma Stores In Latest Sears Closing Announcement",
      "isclickable": true,
      "abstract": "<p>Sears is closing an additional 72 stores this year, according to the retailer.&nbsp; None are in Oklahoma.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16888793_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T07:39:47.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16888793_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T07:39:47.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T08:59:47Z",
    "lastEditedDate": "2018-06-01T11:40:03Z",
    "publishedDate": "2018-06-01T08:59:47Z",
    "updatedDate": "2018-06-01T11:40:03Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T04:59:47.0000000",
      "lastedited": "2018-06-01T07:40:03.0000000",
      "published": "2018-06-01T04:59:47.0000000",
      "updated": "2018-06-01T07:40:03.0000000"
    },
    "seo": {
      "description": "Sears is closing an additional 72 stores this year, according to the retailer.  None are in Oklahoma.",
      "pageurl": "no-oklahoma-stores-in-latest-sears-closing-announcement",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "CBS",
      "lastname": "News",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "NEW YORK"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38324544/bas-bass-pro-shops-hosting-us-bowfishing-championship",
    "id": 38324544,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS04",
      "dateTime": "2018-06-01T07:31:08Z"
    },
    "headline": "BA's Bass Pro Shops Hosting U.S. Bowfishing Championship",
    "abstract": "<p>Broken Arrow's BassPro Shops is hosting the U.S. Open Bowfishing Championship this weekend and it expected to bring hundreds of people to our state. This is the first time the tournament is being held in Oklahoma with first place taking home $25,000.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "BA's Bass Pro Shops Hosting U.S. Bowfishing Championship",
      "isclickable": true,
      "abstract": "<p>Broken Arrow's BassPro Shops is hosting the U.S. Open Bowfishing Championship this weekend and it expected to bring hundreds of people to our state. This is the first time the tournament is being held in Oklahoma with first place taking home $25,000.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16888653_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T07:18:38.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16888653_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T07:18:38.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T11:07:01Z",
    "lastEditedDate": "2018-06-01T11:21:05Z",
    "publishedDate": "2018-06-01T11:07:01Z",
    "updatedDate": "2018-06-01T11:21:05Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T07:07:01.0000000",
      "lastedited": "2018-06-01T07:21:05.0000000",
      "published": "2018-06-01T07:07:01.0000000",
      "updated": "2018-06-01T07:21:05.0000000"
    },
    "seo": {
      "description": "Broken Arrow's BassPro Shops is hosting the U.S. Open Bowfishing Championship this weekend and it expected to bring hundreds of people to our state.",
      "pageurl": "bas-bass-pro-shops-hosting-us-bowfishing-championship",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Tess",
      "lastname": "Maune",
      "title": "News On 6",
      "link": "/story/18814594/tess-maune",
      "emailaddress": "richard.clark@newson6.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/TessMauneNewsOn6",
        "twitter": "TessMaune"
      }
    }],
    "dateline": "BROKEN ARROW, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323833/heat-advisory-for-much-of-oklahoma",
    "id": 38323833,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS20",
      "dateTime": "2018-06-01T13:59:03Z"
    },
    "headline": "Heat Advisory For Much Of Oklahoma",
    "abstract": "<p>Our main issues will involve the heat and humidity for the next two days with the Heat Index values nearing the 105 to 112 range today for the majority of eastern Oklahoma and southern Kansas.&nbsp;</p>",
    "contentClassification": "Weather",
    "cls": 5,
    "abridged": {
      "headline": "Heat Advisory For Much Of Oklahoma",
      "isclickable": true,
      "abstract": "<p>Our main issues will involve the heat and humidity for the next two days with the Heat Index values nearing the 105 to 112 range today for the majority of eastern Oklahoma and southern Kansas.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16888238_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T06:08:50.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16888238_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T06:08:50.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T07:51:16Z",
    "lastEditedDate": "2018-06-01T10:21:00Z",
    "publishedDate": "2018-06-01T07:51:16Z",
    "updatedDate": "2018-06-01T10:21:00Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T03:51:16.0000000",
      "lastedited": "2018-06-01T06:21:00.0000000",
      "published": "2018-06-01T03:51:16.0000000",
      "updated": "2018-06-01T06:21:00.0000000"
    },
    "seo": {
      "description": "Our main issues will involve the heat and humidity for the next two days with the Heat Index values nearing the 105 to 112 range today for the majority of eastern Oklahoma and southern Kansas. ",
      "pageurl": "heat-advisory-for-much-of-oklahoma",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Alan",
      "lastname": "Crone",
      "title": "News On 6 Weather",
      "link": "/story/7460517/alan-crone",
      "emailaddress": "alan.crone@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323832/today-is-last-day-to-register-to-vote-in-june-26th-primary-election",
    "id": 38323832,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS23",
      "dateTime": "2018-06-01T04:27:25Z"
    },
    "headline": "Last Day To Register To Vote In June 26th Primary Election",
    "abstract": "<p>Friday, June 1st, is the last day to register to vote in this month primary election.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Last Day To Register To Vote In June 26th Primary Election",
      "isclickable": true,
      "abstract": "<p>Friday, June 1st, is the last day to register to vote in this month primary election.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887864_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T03:48:56.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887864_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T03:48:56.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T07:49:55Z",
    "lastEditedDate": "2018-06-01T08:21:16Z",
    "publishedDate": "2018-06-01T07:49:55Z",
    "updatedDate": "2018-06-01T08:21:16Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T03:49:55.0000000",
      "lastedited": "2018-06-01T04:21:16.0000000",
      "published": "2018-06-01T03:49:55.0000000",
      "updated": "2018-06-01T04:21:16.0000000"
    },
    "seo": {
      "description": "Friday, June 1st, is the last day to register to vote in this month primary election.",
      "pageurl": "today-is-last-day-to-register-to-vote-in-june-26th-primary-election",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "OKLAHOMA CITY"
  }, {
    "displaysize": "-18",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323745/sand-springs-man-arrested-on-first-degree-murder-complaint",
    "id": 38323745,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS19",
      "dateTime": "2018-06-01T04:11:41Z"
    },
    "headline": "Sand Springs Man Arrested On First-Degree Murder Complaint",
    "abstract": "<p>A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Sand Springs Man Arrested On First-Degree Murder Complaint",
      "isclickable": true,
      "abstract": "<p>A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887801_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T03:24:57.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887801_G.jpg",
      "width": 250,
      "location": "LEFT",
      "caption": "Tulsa County jail photo of Darius Hatfield",
      "lastediteddate": "2018-06-01T03:24:57.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T07:25:13Z",
    "lastEditedDate": "2018-06-01T08:05:26Z",
    "publishedDate": "2018-06-01T07:25:13Z",
    "updatedDate": "2018-06-01T08:05:26Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T03:25:13.0000000",
      "lastedited": "2018-06-01T04:05:26.0000000",
      "published": "2018-06-01T03:25:13.0000000",
      "updated": "2018-06-01T04:05:26.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390397,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T08:07:17.670Z"
    }],
    "seo": {
      "description": "A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.",
      "pageurl": "sand-springs-man-arrested-on-first-degree-murder-complaint",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA COUNTY, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323624/oklahoma-man-accused-of-destroying-arkansas-monument-ordered-to-mental-hospital",
    "id": 38323624,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS26",
      "dateTime": "2018-06-01T03:39:29Z"
    },
    "headline": "OK Man Accused Of Destroying Monument Ordered To Mental Hospital",
    "abstract": "<p>The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "OK Man Accused Of Destroying Monument Ordered To Mental Hospital",
      "isclickable": true,
      "abstract": "<p>The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887757_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T02:48:36.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887757_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T02:48:36.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T06:48:48Z",
    "lastEditedDate": "2018-06-01T07:35:00Z",
    "publishedDate": "2018-06-01T06:48:48Z",
    "updatedDate": "2018-06-01T07:35:00Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T02:48:48.0000000",
      "lastedited": "2018-06-01T03:35:00.0000000",
      "published": "2018-06-01T02:48:48.0000000",
      "updated": "2018-06-01T03:35:00.0000000"
    },
    "seo": {
      "browsertitle": "OK Man Accused Of Destroying Monument Ordered To Mental Hospital",
      "description": "The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect.",
      "pageurl": "oklahoma-man-accused-of-destroying-arkansas-monument-ordered-to-mental-hospital",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com and Wire Reports",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "LITTLE ROCK, Arkansas"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323608/vet-who-once-called-oklahoma-home-to-get-proper-burial-after-sister-found",
    "id": 38323608,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS03",
      "dateTime": "2018-06-01T03:14:53Z"
    },
    "headline": "Vet Who Once Called Oklahoma Home, To Get Proper Burial",
    "abstract": "<p>Officials in Hawaii say the search is over after a family member of late veteran with Oklahoma ties has been found.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Vet Who Once Called Oklahoma Home, To Get Proper Burial",
      "isclickable": true,
      "abstract": "<p>Officials in Hawaii say the search is over after a family member of late veteran with Oklahoma ties has been found.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887753_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T02:42:38.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887753_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T02:42:38.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T06:40:37Z",
    "lastEditedDate": "2018-06-01T07:08:44Z",
    "publishedDate": "2018-06-01T06:40:37Z",
    "updatedDate": "2018-06-01T07:08:44Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T02:40:37.0000000",
      "lastedited": "2018-06-01T03:08:44.0000000",
      "published": "2018-06-01T02:40:37.0000000",
      "updated": "2018-06-01T03:08:44.0000000"
    },
    "seo": {
      "description": "Officials in Hawaii say the search is over after a family member of late veteran with Oklahoma ties has been found.",
      "pageurl": "vet-who-once-called-oklahoma-home-to-get-proper-burial-after-sister-found",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "HONOLULU, Hawaii"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38323655/nhls-st-louis-blues-extend-affiliation-with-tulsa-oilers",
    "id": 38323655,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T03:06:57Z"
    },
    "headline": "NHL's St. Louis Blues Extend Affiliation With Tulsa Oilers",
    "abstract": "<p>The National Hockey League's St. Louis Blues have announced an extension of its affiliate agreement with the Tulsa Oilers of the ECHL.&nbsp;</p>",
    "contentClassification": "Sport",
    "cls": 4,
    "abridged": {
      "headline": "NHL's St. Louis Blues Extend Affiliation With Tulsa Oilers",
      "isclickable": true,
      "abstract": "<p>The National Hockey League's St. Louis Blues have announced an extension of its affiliate agreement with the Tulsa Oilers of the ECHL.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887771_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-06-01T03:05:02.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887771_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-06-01T03:05:02.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T07:05:26Z",
    "lastEditedDate": "2018-06-01T07:06:56Z",
    "publishedDate": "2018-06-01T07:05:26Z",
    "updatedDate": "2018-06-01T07:05:26Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-06-01T03:05:26.0000000",
      "lastedited": "2018-06-01T03:06:56.0000000",
      "published": "2018-06-01T03:05:26.0000000",
      "updated": "2018-06-01T03:05:26.0000000"
    },
    "seo": {
      "description": "The National Hockey League's St. Louis Blues have announced an extension of its affiliate agreement with the Tulsa Oilers of the ECHL.",
      "pageurl": "nhls-st-louis-blues-extend-affiliation-with-tulsa-oilers",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Associated Press"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38322979/witness-to-attack-on-tps-officer-sets-story-straight",
    "id": 38322979,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS21",
      "dateTime": "2018-05-31T23:59:38Z"
    },
    "headline": "Witness To Attack On TPS Officer Sets Story Straight",
    "abstract": "<p>A witness to an attack on a TPS police officer wants to set the story straight. He says reports the officer threw the suspect onto his windshield aren&rsquo;t true. 05/30/2018 Related Story:&nbsp;Suspect Smashes TPS Patrol Car Windshield During Fight, TPD Says John Jestice works at the Oklahoma Army Surplus store. He was there when he says the suspect jumped onto the police officer's hood and smashed the windshield in himself. &quot;No, Tony did not throw the person, he did that al...</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Witness To Attack On TPS Officer Sets Story Straight",
      "isclickable": true,
      "abstract": "<p>A witness to an attack on a TPS police officer wants to set the story straight. He says reports the officer threw the suspect onto his windshield aren&rsquo;t true. 05/30/2018 Related Story:&nbsp;Suspect Smashes TPS Patrol Car Windshield During Fight, TPD Says John Jestice works at the Oklahoma Army Surplus store. He was there when he says the suspect jumped onto the police officer's hood and smashed the windshield in himself. &quot;No, Tony did not throw the person, he did that al...</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16887143_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T23:50:23.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16887143_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T23:50:23.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T03:27:56Z",
    "lastEditedDate": "2018-06-01T03:50:32Z",
    "publishedDate": "2018-06-01T03:27:56Z",
    "updatedDate": "2018-06-01T03:50:32Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T23:27:56.0000000",
      "lastedited": "2018-05-31T23:50:32.0000000",
      "published": "2018-05-31T23:27:56.0000000",
      "updated": "2018-05-31T23:50:32.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390135,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:52:32.083Z"
    }],
    "seo": {
      "description": "A witness to an attack on a TPS police officer wants to set the story straight. He says reports the officer threw the suspect onto his windshield aren’t true. 05/30/2018 Related Story: Suspect Sma...",
      "pageurl": "witness-to-attack-on-tps-officer-sets-story-straight",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Taylor",
      "lastname": "Newcomb",
      "title": "News On 6",
      "link": "/story/34623007/taylor-newcomb",
      "emailaddress": "richard.clark@newson6.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/taylornewcombnews/",
        "twitter": "taymnewcomb"
      }
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38317461/okc-police-investigate-toddlers-death",
    "id": 38317461,
    "status": "Live",
    "owner": {
      "id": 690,
      "name": "KWTV",
      "baseurl": "www.news9.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN01",
      "dateTime": "2018-05-31T23:35:16Z"
    },
    "headline": "OKC Police Investigate Toddler's Death",
    "abstract": "<p>A 3-year-old girl has died from&nbsp;injuries suffered from abuse, Oklahoma City police said.</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "OKC Police Investigate Toddler's Death",
      "isclickable": true,
      "abstract": "<p>A 3-year-old girl has died from&nbsp;injuries suffered from abuse, Oklahoma City police said.</p>",
      "abstractimage": {
        "filename": "http://KWTV.images.worldnow.com/images/16886652_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T22:32:46.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KWTV.images.worldnow.com/images/16886652_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T22:32:46.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-05-31T15:11:44Z",
    "lastEditedDate": "2018-06-01T03:35:16Z",
    "publishedDate": "2018-05-31T15:11:44Z",
    "updatedDate": "2018-06-01T03:34:14Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T11:11:44.0000000",
      "lastedited": "2018-05-31T23:35:16.0000000",
      "published": "2018-05-31T11:11:44.0000000",
      "updated": "2018-05-31T23:34:14.0000000"
    },
    "seo": {
      "keywords": "oklahoma city,okc,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,channel 9,channel nine,news 9,television,this morning,live radar,kwtv,Child Abuse, murder, Homicide, death",
      "description": "A 3-year-old girl has died from injuries suffered from abuse, Oklahoma City police said.",
      "pageurl": "okc-police-investigate-toddlers-death",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By",
      "firstname": "LeighAnne",
      "lastname": "Manwarren",
      "title": "News9.com",
      "emailaddress": "ryan.welton@news9.net"
    }],
    "dateline": "OKLAHOMA CITY",
    "topics": [{
      "type": "topic",
      "value": "Child Abuse"
    }, {
      "type": "topic",
      "value": "murder"
    }, {
      "type": "topic",
      "value": "Homicide"
    }, {
      "type": "topic",
      "value": "death"
    }]
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38322603/love-for-historic-route-66-brings-more-visitors-to-oklahoma",
    "id": 38322603,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN04",
      "dateTime": "2018-05-31T23:58:08Z"
    },
    "headline": "Love For Historic Route 66 Brings More Visitors To Oklahoma",
    "abstract": "<p>Lucille&rsquo;s, the Round Barn, Pops, and the Blue Whale are just a few of the Historic Route 66 icons attracting visitors from across the world to our state. America's Main Street stretches across eight states with the most miles passing through Oklahoma.&nbsp;</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Love For Historic Route 66 Brings More Visitors To Oklahoma",
      "isclickable": true,
      "abstract": "<p>Lucille&rsquo;s, the Round Barn, Pops, and the Blue Whale are just a few of the Historic Route 66 icons attracting visitors from across the world to our state. America's Main Street stretches across eight states with the most miles passing through Oklahoma.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16886801_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T22:56:21.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16886801_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T22:56:21.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T02:13:38Z",
    "lastEditedDate": "2018-06-01T02:56:42Z",
    "publishedDate": "2018-06-01T02:13:38Z",
    "updatedDate": "2018-06-01T02:56:42Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T22:13:38.0000000",
      "lastedited": "2018-05-31T22:56:42.0000000",
      "published": "2018-05-31T22:13:38.0000000",
      "updated": "2018-05-31T22:56:42.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390162,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:58:08.400Z"
    }],
    "seo": {
      "description": "Lucille’s, the Round Barn, Pops, and the Blue Whale are just a few of the Historic Route 66 icons attracting visitors from across the world to our state. America's Main Street stretches across eigh...",
      "pageurl": "love-for-historic-route-66-brings-more-visitors-to-oklahoma",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Craig",
      "lastname": "Day",
      "title": "News On 6",
      "link": "/story/7460449/craig-day",
      "emailaddress": "craig.day@newson6.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/CraigDayNewsOn6",
        "twitter": "craigday6"
      }
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38321707/tulsa-county-deputies-respond-to-shooting",
    "id": 38321707,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-05-31T23:48:40Z"
    },
    "headline": "One Dead, One In Custody At Tulsa County Shooting",
    "abstract": "<p>One person is dead and another is in custody after a shooting in Tulsa County.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "One Dead, One In Custody At Tulsa County Shooting",
      "isclickable": true,
      "abstract": "<p>One person is dead and another is in custody after a shooting in Tulsa County.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16885494_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T19:22:58.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16885494_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T19:22:58.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-05-31T22:52:29Z",
    "lastEditedDate": "2018-06-01T02:36:39Z",
    "publishedDate": "2018-05-31T22:52:29Z",
    "updatedDate": "2018-06-01T02:36:39Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T18:52:29.0000000",
      "lastedited": "2018-05-31T22:36:39.0000000",
      "published": "2018-05-31T18:52:29.0000000",
      "updated": "2018-05-31T22:36:39.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390097,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:48:40.503Z"
    }],
    "seo": {
      "description": "One person is dead and another is in custody after a shooting in Tulsa County.",
      "pageurl": "tulsa-county-deputies-respond-to-shooting",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "Amy",
      "lastname": "Kauffman",
      "title": "News On 6",
      "link": "/story/34435381/amy-kauffman",
      "emailaddress": "richard.clark@newson6.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/amykauffmantv/",
        "twitter": "amykauffmantv"
      }
    }],
    "dateline": "TULSA COUNTY, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38322631/tulsans-gather-in-greenwood-district-to-mark-97th-anniversary-tulsa-race-riots",
    "id": 38322631,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-05-31T23:35:17Z"
    },
    "headline": "Tulsans Gather In Greenwood District To Mark 97th Anniversary Tulsa Race Riots",
    "abstract": "<p>Many in Tulsa are taking time to remember the lives lost on this day in 1921 during the Tulsa Race Riots. Thursday people walked through the Greenwood District to mark the&nbsp;day.</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Tulsans Gather In Greenwood District To Mark 97th Anniversary Tulsa Race Riots",
      "isclickable": true,
      "abstract": "<p>Many in Tulsa are taking time to remember the lives lost on this day in 1921 during the Tulsa Race Riots. Thursday people walked through the Greenwood District to mark the&nbsp;day.</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16886594_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T22:18:02.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16886594_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T22:18:02.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T02:21:25Z",
    "lastEditedDate": "2018-06-01T02:21:25Z",
    "publishedDate": "2018-06-01T02:21:25Z",
    "updatedDate": "2018-06-01T02:21:25Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T22:21:25.0000000",
      "lastedited": "2018-05-31T22:21:25.0000000",
      "published": "2018-05-31T22:21:25.0000000",
      "updated": "2018-05-31T22:21:25.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390036,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:35:17.700Z"
    }],
    "seo": {
      "browsertitle": "Tulsans Gather In Greenwood District To Mark 97th Anniversary Tu",
      "description": "Many in Tulsa are taking time to remember the lives lost on this day in 1921 during the Tulsa Race Riots. Thursday people walked through the Greenwood District to mark the day.",
      "pageurl": "tulsans-gather-in-greenwood-district-to-mark-97th-anniversary-tulsa-race-riots",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38322474/police-search-for-man-accused-in-mothers-brutal-attack",
    "id": 38322474,
    "status": "Live",
    "owner": {
      "id": 690,
      "name": "KWTV",
      "baseurl": "www.news9.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN01",
      "dateTime": "2018-06-01T10:17:07Z"
    },
    "headline": "Police Search For Man Accused In Mother’s Brutal Attack",
    "abstract": "<p>David Nelson had been staying with his mother at her apartment complex in a busy part of Moore.&nbsp;</p>",
    "contentClassification": "Crime",
    "cls": 566,
    "abridged": {
      "headline": "Police Search For Man Accused In Mother’s Brutal Attack",
      "isclickable": true,
      "abstract": "<p>David Nelson had been staying with his mother at her apartment complex in a busy part of Moore.&nbsp;</p>",
      "abstractimage": {
        "filename": "http://KWTV.images.worldnow.com/images/16886529_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T22:04:30.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KWTV.images.worldnow.com/images/16886529_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T22:04:30.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T01:36:36Z",
    "lastEditedDate": "2018-06-01T02:11:00Z",
    "publishedDate": "2018-06-01T01:36:36Z",
    "updatedDate": "2018-06-01T02:11:00Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T21:36:36.0000000",
      "lastedited": "2018-05-31T22:11:00.0000000",
      "published": "2018-05-31T21:36:36.0000000",
      "updated": "2018-05-31T22:11:00.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390061,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:46:00.230Z"
    }, {
      "type": "Clip",
      "id": 14390836,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T14:17:07.453Z"
    }],
    "seo": {
      "description": "David Nelson had been staying with his mother at her apartment complex in a busy part of Moore. ",
      "pageurl": "police-search-for-man-accused-in-mothers-brutal-attack",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By",
      "firstname": "Christy",
      "lastname": "Lewis",
      "title": "News 9",
      "link": "/story/26668431/christy-lewis",
      "emailaddress": "ryan.welton@news9.net",
      "socialnetworksinfo": {
        "facebookpage": "https://www.facebook.com/ChristyLewisNews9",
        "twitter": "LewisChristy"
      }
    }],
    "dateline": "MOORE, Oklahoma"
  }, {
    "displaysize": "-10",
    "displayorder": "1",
    "isimplicit": false,
    "type": "story",
    "link": "http://www.newson6.com/story/38322580/tulsa-civil-rights-groups-call-for-police-reform",
    "id": 38322580,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-05-31T23:37:56Z"
    },
    "headline": "Tulsa Civil Rights Groups Call For Police Reform",
    "abstract": "<p>On the 97th Anniversary of the Tulsa Race Riots, Civil Rights and faith leaders in Green Country are calling for police reforms within the Tulsa Police Department. .</p>",
    "contentClassification": "News",
    "cls": 3,
    "abridged": {
      "headline": "Tulsa Civil Rights Groups Call For Police Reform",
      "isclickable": true,
      "abstract": "<p>On the 97th Anniversary of the Tulsa Race Riots, Civil Rights and faith leaders in Green Country are calling for police reforms within the Tulsa Police Department. .</p>",
      "abstractimage": {
        "filename": "http://KOTV.images.worldnow.com/images/16886545_G.jpg",
        "width": 115,
        "location": "LEFT",
        "lastediteddate": "2018-05-31T22:08:06.0000000"
      }
    },
    "abstractimage": {
      "filename": "http://KOTV.images.worldnow.com/images/16886545_G.jpg",
      "width": 250,
      "location": "LEFT",
      "lastediteddate": "2018-05-31T22:08:06.0000000"
    },
    "options": {
      "date": {
        "creation": {
          "showonstory": true
        },
        "lastedited": {
          "showonstory": true,
          "showonabstract": false
        },
        "published": {
          "showonstory": true,
          "showonabstract": true
        },
        "updated": {
          "showonstory": true,
          "showonabstract": false
        }
      },
      "socialtools": {
        "comments": {
          "display": false
        },
        "ratings": {
          "display": false
        }
      }
    },
    "creationDate": "2018-06-01T02:08:34Z",
    "lastEditedDate": "2018-06-01T02:08:33Z",
    "publishedDate": "2018-06-01T02:08:34Z",
    "updatedDate": "2018-06-01T02:08:34Z",
    "sortbydatetype": "LastEdited",
    "datetime": {
      "created": "2018-05-31T22:08:34.0000000",
      "lastedited": "2018-05-31T22:08:33.0000000",
      "published": "2018-05-31T22:08:34.0000000",
      "updated": "2018-05-31T22:08:34.0000000"
    },
    "surfaceable": [{
      "type": "Clip",
      "id": 14390046,
      "status": "L",
      "displaysize": 37,
      "displayorder": 1,
      "sortbydate": "2018-06-01T03:37:56.133Z"
    }],
    "seo": {
      "description": "On the 97th Anniversary of the Tulsa Race Riots, Civil Rights and faith leaders in Green Country are calling for police reforms within the Tulsa Police Department. .",
      "pageurl": "tulsa-civil-rights-groups-call-for-police-reform",
      "includedate": false
    },
    "bylines": [{
      "type": "byline",
      "prefix": "By:",
      "firstname": "NewsOn6.com",
      "emailaddress": "richard.clark@newson6.net"
    }],
    "dateline": "TULSA, Oklahoma"
  }, {
    "displaysize": "7",
    "displayorder": "1",
    "isimplicit": false,
    "type": "category",
    "link": "http://www.newson6.com/category/53065/oklahoma-headlines",
    "id": 53065,
    "status": "Live",
    "owner": {
      "id": 324,
      "name": "APOK",
      "enablecommentsonshare": true
    },
    "build": {
      "machinename": "IIS04",
      "dateTime": "2018-06-01T15:35:17Z"
    },
    "iscontrolledcategory": false,
    "isHomeCategory": false,
    "headline": "Oklahoma Headlines",
    "abstract": "",
    "sectiontitle": "Oklahoma Headlines",
    "contentClassification": "News - AP-State",
    "cls": 297,
    "lastediteddate": "2004-05-03T14:13:27Z",
    "creationDate": "2004-05-03T14:13:27Z",
    "datetime": {
      "created": "2004-05-03T10:13:27.0000000",
      "lastedited": "2004-05-03T10:13:27.0000000"
    },
    "abridged": {
      "headline": "Oklahoma Headlines",
      "isclickable": true
    },
    "seo": {
      "pageurl": "oklahoma-headlines"
    },
    "nested": {
      "features": [{
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38326611/princes-estate-sues-oklahoma-man-over-posted-music-videos",
        "id": 38326611,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS17",
          "dateTime": "2018-06-01T11:29:12Z"
        },
        "headline": "Prince's estate sues Oklahoma man over posted music videos",
        "abstract": "Prince&#39;s estate is suing an Oklahoma man for alleged copyright infringement.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Prince's estate sues Oklahoma man over posted music videos",
          "isclickable": true,
          "abstract": "Prince&#39;s estate is suing an Oklahoma man for alleged copyright infringement."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T15:29:05Z",
        "lastEditedDate": "2018-06-01T15:29:05Z",
        "publishedDate": "2018-06-01T15:29:05Z",
        "updatedDate": "2018-06-01T15:29:05Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T11:29:05.0000000",
          "lastedited": "2018-06-01T11:29:05.0000000",
          "published": "2018-06-01T11:29:05.0000000",
          "updated": "2018-06-01T11:29:05.0000000"
        },
        "seo": {
          "description": "Prince's estate is suing an Oklahoma man for alleged copyright infringement.",
          "pageurl": "princes-estate-sues-oklahoma-man-over-posted-music-videos",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/32184648/news-minute-here-is-the-latest-oklahoma-news-from-the-associated-press-at-740-am-cdt",
        "id": 32184648,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS04",
          "dateTime": "2018-06-01T15:35:17Z"
        },
        "headline": "News Minute: Here is the latest Oklahoma news from The Associated Press at 7:40 a.m. CDT",
        "abstract": "A report says a business conditions index for nine Midwest and Plains states has jumped to its highest level in 14 years. The report released Friday says the Mid-America Business Conditions Index hit 67.3 last month,...",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "News Minute: Here is the latest Oklahoma news from The Associated Press at 7:40 a.m. CDT",
          "isclickable": true,
          "abstract": "The Oklahoma medical examiner&#39;s office has ruled that the fiery car crash in which energy industry magnate Aubrey McClendon died was an accident. An autopsy report released Wednesday showed the 56-year-old had..."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-06-09T15:42:31Z",
        "lastEditedDate": "2018-06-01T12:44:54Z",
        "publishedDate": "2017-06-08T16:45:11Z",
        "updatedDate": "2018-06-01T12:44:55Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-06-09T11:42:31.0000000",
          "lastedited": "2018-06-01T08:44:54.0000000",
          "published": "2017-06-08T12:45:11.0000000",
          "updated": "2018-06-01T08:44:55.0000000"
        },
        "seo": {
          "browsertitle": "News Minute: Here is the latest Oklahoma news from The Associate",
          "description": "A report says a business conditions index for nine Midwest and Plains states has jumped to its highest level in 14 years. The report released Friday says the Mid-America Business Conditions...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "news-minute-here-is-the-latest-oklahoma-news-from-the-associated-press-at-740-am-cdt",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38324749/survey-report-suggests-midwest-economy-still-steaming-ahead",
        "id": 38324749,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS03",
          "dateTime": "2018-06-01T07:40:07Z"
        },
        "headline": "Survey report suggests Midwest economy still steaming ahead",
        "abstract": "A report says a business conditions index for nine Midwest and Plains states has jumped to its highest level in 14 years.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Survey report suggests Midwest economy still steaming ahead",
          "isclickable": true,
          "abstract": "A report says a business conditions index for nine Midwest and Plains states has jumped to its highest level in 14 years."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T11:36:40Z",
        "lastEditedDate": "2018-06-01T11:38:15Z",
        "publishedDate": "2018-06-01T11:36:40Z",
        "updatedDate": "2018-06-01T11:38:15Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T07:36:40.0000000",
          "lastedited": "2018-06-01T07:38:15.0000000",
          "published": "2018-06-01T07:36:40.0000000",
          "updated": "2018-06-01T07:38:15.0000000"
        },
        "seo": {
          "description": "A report says a business conditions index for nine Midwest and Plains states has jumped to its highest level in 14 years.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "survey-report-suggests-midwest-economy-still-steaming-ahead",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38320835/fallin-taps-longtime-gop-leader-as-secretary-of-state",
        "id": 38320835,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-05-31T17:04:46Z"
        },
        "headline": "Fallin taps longtime GOP leader as secretary of state",
        "abstract": "Gov. Mary Fallin has chosen her general counsel to be the next secretary of state.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Fallin taps longtime GOP leader as secretary of state",
          "isclickable": true,
          "abstract": "Gov. Mary Fallin has chosen her general counsel to be the next secretary of state."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T21:04:47Z",
        "lastEditedDate": "2018-05-31T21:04:46Z",
        "publishedDate": "2018-05-31T21:04:47Z",
        "updatedDate": "2018-05-31T21:04:47Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T17:04:47.0000000",
          "lastedited": "2018-05-31T17:04:46.0000000",
          "published": "2018-05-31T17:04:47.0000000",
          "updated": "2018-05-31T17:04:47.0000000"
        },
        "seo": {
          "description": "Gov. Mary Fallin has chosen her general counsel to be the next secretary of state.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "fallin-taps-longtime-gop-leader-as-secretary-of-state",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38320231/charges-against-man-who-forced-flight-diversion-to-oklahoma",
        "id": 38320231,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS05",
          "dateTime": "2018-05-31T16:08:42Z"
        },
        "headline": "Charges against man who forced flight diversion to Oklahoma",
        "abstract": "Investigators say charges have been filed against a man whose screaming and threats aboard a Delta Air Lines flight prompted an emergency landing in Oklahoma.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Charges against man who forced flight diversion to Oklahoma",
          "isclickable": true,
          "abstract": "Investigators say charges have been filed against a man whose screaming and threats aboard a Delta Air Lines flight prompted an emergency landing in Oklahoma."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T20:08:08Z",
        "lastEditedDate": "2018-05-31T20:08:08Z",
        "publishedDate": "2018-05-31T20:08:08Z",
        "updatedDate": "2018-05-31T20:08:08Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T16:08:08.0000000",
          "lastedited": "2018-05-31T16:08:08.0000000",
          "published": "2018-05-31T16:08:08.0000000",
          "updated": "2018-05-31T16:08:08.0000000"
        },
        "seo": {
          "description": "Investigators say charges have been filed against a man whose screaming and threats aboard a Delta Air Lines flight prompted an emergency landing in Oklahoma.",
          "pageurl": "charges-against-man-who-forced-flight-diversion-to-oklahoma",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38319578/resentencing-ordered-for-tulsa-man-who-killed-ex-girlfriend",
        "id": 38319578,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-05-31T14:52:19Z"
        },
        "headline": "Resentencing ordered for Tulsa man who killed ex-girlfriend",
        "abstract": "A Tulsa man sentenced to life in prison without parole for killing his former girlfriend will receive a new sentencing hearing.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Resentencing ordered for Tulsa man who killed ex-girlfriend",
          "isclickable": true,
          "abstract": "A Tulsa man sentenced to life in prison without parole for killing his former girlfriend will receive a new sentencing hearing."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T18:52:19Z",
        "lastEditedDate": "2018-05-31T18:52:19Z",
        "publishedDate": "2018-05-31T18:52:19Z",
        "updatedDate": "2018-05-31T18:52:19Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T14:52:19.0000000",
          "lastedited": "2018-05-31T14:52:19.0000000",
          "published": "2018-05-31T14:52:19.0000000",
          "updated": "2018-05-31T14:52:19.0000000"
        },
        "seo": {
          "description": "A Tulsa man sentenced to life in prison without parole for killing his former girlfriend will receive a new sentencing hearing.",
          "pageurl": "resentencing-ordered-for-tulsa-man-who-killed-ex-girlfriend",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38317796/death-sentence-upheld-for-oklahoman-in-bus-station-stabbing",
        "id": 38317796,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-05-31T11:39:36Z"
        },
        "headline": "Death sentence upheld for Oklahoman in bus station stabbing",
        "abstract": "The Oklahoma Court of Criminal Appeals has upheld the murder conviction and death sentence of a man who stabbed his estranged girlfriend to death at an Oklahoma City bus station.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Death sentence upheld for Oklahoman in bus station stabbing",
          "isclickable": true,
          "abstract": "The Oklahoma Court of Criminal Appeals has upheld the murder conviction and death sentence of a man who stabbed his estranged girlfriend to death at an Oklahoma City bus station."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T15:39:36Z",
        "lastEditedDate": "2018-05-31T15:39:36Z",
        "publishedDate": "2018-05-31T15:39:36Z",
        "updatedDate": "2018-05-31T15:39:36Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T11:39:36.0000000",
          "lastedited": "2018-05-31T11:39:36.0000000",
          "published": "2018-05-31T11:39:36.0000000",
          "updated": "2018-05-31T11:39:36.0000000"
        },
        "seo": {
          "description": "The Oklahoma Court of Criminal Appeals has upheld the murder conviction and death sentence of a man who stabbed his estranged girlfriend to death at an Oklahoma City bus station.",
          "pageurl": "death-sentence-upheld-for-oklahoman-in-bus-station-stabbing",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38317460/court-sends-accused-monument-destroyer-to-mental-hospital",
        "id": 38317460,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-05-31T11:11:42Z"
        },
        "headline": "Court sends accused monument destroyer to mental hospital",
        "abstract": "The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Court sends accused monument destroyer to mental hospital",
          "isclickable": true,
          "abstract": "The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T15:11:42Z",
        "lastEditedDate": "2018-05-31T15:11:42Z",
        "publishedDate": "2018-05-31T15:11:42Z",
        "updatedDate": "2018-05-31T15:11:42Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T11:11:42.0000000",
          "lastedited": "2018-05-31T11:11:42.0000000",
          "published": "2018-05-31T11:11:42.0000000",
          "updated": "2018-05-31T11:11:42.0000000"
        },
        "seo": {
          "description": "The man accused of destroying a Ten Commandments monument outside the Arkansas state Capitol has been acquitted of a felony charge by a judge who cited evidence of a mental disease or defect.",
          "pageurl": "court-sends-accused-monument-destroyer-to-mental-hospital",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38316244/fallin-lifts-burn-ban-in-5-counties-in-western-oklahoma",
        "id": 38316244,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS03",
          "dateTime": "2018-05-31T09:10:55Z"
        },
        "headline": "Fallin lifts burn ban in 5 counties in western Oklahoma",
        "abstract": "Oklahoma Gov. Mary Fallin is lifting burning restrictions in five of the seven counties that were under a burn ban because of extreme fire conditions.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Fallin lifts burn ban in 5 counties in western Oklahoma",
          "isclickable": true,
          "abstract": "Oklahoma Gov. Mary Fallin is lifting burning restrictions in five of the seven counties that were under a burn ban because of extreme fire conditions."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T13:07:35Z",
        "lastEditedDate": "2018-05-31T13:09:00Z",
        "publishedDate": "2018-05-31T13:07:35Z",
        "updatedDate": "2018-05-31T13:09:00Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T09:07:35.0000000",
          "lastedited": "2018-05-31T09:09:00.0000000",
          "published": "2018-05-31T09:07:35.0000000",
          "updated": "2018-05-31T09:09:00.0000000"
        },
        "seo": {
          "description": "Oklahoma Gov. Mary Fallin is lifting burning restrictions in five of the seven counties that were under a burn ban because of extreme fire conditions.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "fallin-lifts-burn-ban-in-5-counties-in-western-oklahoma",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38313137/man-killed-in-crop-dusting-airplane-crash-near-oklahoma-city",
        "id": 38313137,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "IIS16",
          "dateTime": "2018-05-30T23:36:50Z"
        },
        "headline": "Man killed in crop-dusting airplane crash near Oklahoma City",
        "abstract": "A crop-dusting airplane clipped a support wire to a radio transmitting tower and crashed in central Oklahoma, killing the pilot.",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "Man killed in crop-dusting airplane crash near Oklahoma City",
          "isclickable": true,
          "abstract": "A crop-dusting airplane clipped a support wire to a radio transmitting tower and crashed in central Oklahoma, killing the pilot."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T03:36:01Z",
        "lastEditedDate": "2018-05-31T03:36:01Z",
        "publishedDate": "2018-05-31T03:36:01Z",
        "updatedDate": "2018-05-31T03:36:01Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-30T23:36:01.0000000",
          "lastedited": "2018-05-30T23:36:01.0000000",
          "published": "2018-05-30T23:36:01.0000000",
          "updated": "2018-05-30T23:36:01.0000000"
        },
        "seo": {
          "description": "A crop-dusting airplane clipped a support wire to a radio transmitting tower and crashed in central Oklahoma, killing the pilot.",
          "pageurl": "man-killed-in-crop-dusting-airplane-crash-near-oklahoma-city",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38309740/the-latest-delta-says-unruly-customer-caused-flight-delay",
        "id": 38309740,
        "status": "Live",
        "owner": {
          "id": 324,
          "name": "APOK",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN03",
          "dateTime": "2018-05-30T15:26:47Z"
        },
        "headline": "The Latest: Delta says 'unruly' customer caused flight delay",
        "abstract": "The Latest on a Delta Air Lines flight diverted to Tulsa, Oklahoma, because of an onboard disturbance involving a passenger (all times local):",
        "contentClassification": "News - AP-State",
        "cls": 297,
        "abridged": {
          "headline": "The Latest: Delta says 'unruly' customer caused flight delay",
          "isclickable": true,
          "abstract": "The Latest on a Delta Air Lines flight diverted to Tulsa, Oklahoma, because of an onboard disturbance involving a passenger (all times local):"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-30T19:26:47Z",
        "lastEditedDate": "2018-05-30T19:26:47Z",
        "publishedDate": "2018-05-30T19:26:47Z",
        "updatedDate": "2018-05-30T19:26:47Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-30T15:26:47.0000000",
          "lastedited": "2018-05-30T15:26:47.0000000",
          "published": "2018-05-30T15:26:47.0000000",
          "updated": "2018-05-30T15:26:47.0000000"
        },
        "seo": {
          "description": "The Latest on a Delta Air Lines flight diverted to Tulsa, Oklahoma, because of an onboard disturbance involving a passenger (all times local):",
          "pageurl": "the-latest-delta-says-unruly-customer-caused-flight-delay",
          "includedate": false
        }
      }],
      "totalresults": 11
    }
  }, {
    "displaysize": "7",
    "displayorder": "2",
    "isimplicit": false,
    "type": "category",
    "link": "http://www.newson6.com/category/13530/national-news",
    "id": 13530,
    "status": "Live",
    "owner": {
      "id": 153,
      "name": "AP",
      "baseurl": "ap.worldnow.com",
      "enablecommentsonshare": true
    },
    "build": {
      "machinename": "NJTASKRUN01",
      "dateTime": "2018-06-01T17:19:29Z"
    },
    "iscontrolledcategory": false,
    "isHomeCategory": false,
    "headline": "National - Headline",
    "ads": [{
      "type": "ad",
      "sz": "wnsz_41",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }, {
      "type": "ad",
      "sz": "wnsz_43",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }, {
      "type": "ad",
      "sz": "wnsz_46",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }, {
      "type": "ad",
      "sz": "wnsz_49",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }, {
      "type": "ad",
      "sz": "wnsz_52",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }, {
      "type": "ad",
      "sz": "wnsz_85",
      "show": true,
      "owner": "nat",
      "splitpct": 100
    }],
    "abstract": "Click through for national news stories.",
    "contentClassification": "News - AP-National",
    "cls": 298,
    "lastediteddate": "2012-12-18T19:02:30Z",
    "creationDate": "2001-03-24T09:12:01Z",
    "datetime": {
      "created": "2001-03-24T04:12:01.0000000",
      "lastedited": "2012-12-18T14:02:30.0000000"
    },
    "abridged": {
      "headline": "National",
      "isclickable": true
    },
    "seo": {
      "browsertitle": "National News",
      "robot": "Index,Follow,NoArchive",
      "pageurl": "national-news"
    },
    "nested": {
      "features": [{
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38327927/bare-knuckle-boxing-from-a-bygone-era-looks-for-a-comeback",
        "id": 38327927,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-06-01T17:19:29Z"
        },
        "headline": "Bare-knuckle boxing from a bygone era looks for a comeback",
        "abstract": "Bare-knuckle boxing _ the way it was done back in the 1800s, in the days of the great John L. Sullivan _ is looking to make a comeback, starting with a 10-bout event in Wyoming on Saturday night.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Bare-knuckle boxing from a bygone era looks for a comeback",
          "isclickable": true,
          "abstract": "Bare-knuckle boxing _ the way it was done back in the 1800s, in the days of the great John L. Sullivan _ is looking to make a comeback, starting with a 10-bout event in Wyoming on Saturday night.",
          "abstractimage": {
            "filename": "http://images.worldnow.com/AP/images/16891733_G.jpg",
            "width": 90,
            "location": "LEFT",
            "caption": "(AP Photo/Bob Moen). In this Thursday, May 31, 2018 photo, fighter Bobby Gunn, left, and Bryan Pedersen, chairman of the Wyoming State Board of Mixed Martial Arts, speak with reporters during a news conference to promote a bare-knuckle boxing event tha...",
            "lastediteddate": "2018-06-01T14:09:00.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://images.worldnow.com/AP/images/16891733_G.jpg",
          "width": 90,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T14:09:00.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T18:08:59Z",
        "lastEditedDate": "2018-06-01T21:19:28Z",
        "publishedDate": "2018-06-01T18:08:59Z",
        "updatedDate": "2018-06-01T21:18:39Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T14:08:59.0000000",
          "lastedited": "2018-06-01T17:19:28.0000000",
          "published": "2018-06-01T14:08:59.0000000",
          "updated": "2018-06-01T17:18:39.0000000"
        },
        "seo": {
          "description": "In 1889, the great John L. Sullivan, the Boston Strong Boy, beat Jake Kilrain in 75 rounds - yes, 75 - in what the International Boxing Hall of Fame has called the \"last significant...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "bare-knuckle-boxing-from-a-bygone-era-looks-for-a-comeback",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38327986/blacks-fare-surprisingly-well-in-prostate-cancer-research",
        "id": 38327986,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-06-01T17:19:08Z"
        },
        "headline": "Blacks fare surprisingly well in prostate cancer research",
        "abstract": "Black men with advanced prostate cancer fare surprisingly well in research that challenges current thinking about racial disparities in the disease.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Blacks fare surprisingly well in prostate cancer research",
          "isclickable": true,
          "abstract": "Black men with advanced prostate cancer fare surprisingly well in research that challenges current thinking about racial disparities in the disease."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T18:19:28Z",
        "lastEditedDate": "2018-06-01T21:19:08Z",
        "publishedDate": "2018-06-01T18:19:28Z",
        "updatedDate": "2018-06-01T21:18:15Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T14:19:28.0000000",
          "lastedited": "2018-06-01T17:19:08.0000000",
          "published": "2018-06-01T14:19:28.0000000",
          "updated": "2018-06-01T17:18:15.0000000"
        },
        "seo": {
          "description": "Black men with advanced prostate cancer fared surprisingly well in two new studies that challenge current thinking about racial disparities in the disease.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "blacks-fare-surprisingly-well-in-prostate-cancer-research",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38327598/sip-and-ship-tourists-can-now-send-distillery-whiskey-home",
        "id": 38327598,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN02",
          "dateTime": "2018-06-01T17:18:49Z"
        },
        "headline": "Sip and ship: Tourists can now send distillery whiskey home",
        "abstract": "The whiskey industry is celebrating a new Kentucky law that will allow tourists to have bottles shipped from distilleries to their homes.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Sip and ship: Tourists can now send distillery whiskey home",
          "isclickable": true,
          "abstract": "The whiskey industry is celebrating a new Kentucky law that will allow tourists to have bottles shipped from distilleries to their homes."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T17:28:08Z",
        "lastEditedDate": "2018-06-01T21:18:49Z",
        "publishedDate": "2018-06-01T17:28:08Z",
        "updatedDate": "2018-06-01T21:17:46Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T13:28:08.0000000",
          "lastedited": "2018-06-01T17:18:49.0000000",
          "published": "2018-06-01T13:28:08.0000000",
          "updated": "2018-06-01T17:17:46.0000000"
        },
        "seo": {
          "description": "Until recently, whiskey tourists in Kentucky had been allowed to sniff the aromas of bourbon-making and sip the finished product during distillery tours. But they couldn't legally ship...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "sip-and-ship-tourists-can-now-send-distillery-whiskey-home",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38325246/us-unemployment-falls-to-nearly-1969-levels-hiring-solid",
        "id": 38325246,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN02",
          "dateTime": "2018-06-01T17:18:30Z"
        },
        "headline": "US unemployment falls to nearly 1969 levels; hiring solid",
        "abstract": "US employers added 223,000 jobs last month, unemployment rate fell to 18-year low of 3.8 pct.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "US unemployment falls to nearly 1969 levels; hiring solid",
          "isclickable": true,
          "abstract": "US employers added 223,000 jobs last month, unemployment rate fell to 18-year low of 3.8 pct."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T12:37:03Z",
        "lastEditedDate": "2018-06-01T21:18:30Z",
        "publishedDate": "2018-06-01T12:37:03Z",
        "updatedDate": "2018-06-01T21:17:33Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T08:37:03.0000000",
          "lastedited": "2018-06-01T17:18:30.0000000",
          "published": "2018-06-01T08:37:03.0000000",
          "updated": "2018-06-01T17:17:33.0000000"
        },
        "seo": {
          "description": "Another month of strong hiring drove the nation's unemployment rate down to 3.8 percent - tantalizingly close to the level last seen in 1969, when Detroit still dominated the auto industry...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "us-unemployment-falls-to-nearly-1969-levels-hiring-solid",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38326551/vermont-to-pay-up-to-10k-to-new-residents-who-work-remotely",
        "id": 38326551,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN05",
          "dateTime": "2018-06-01T17:18:17Z"
        },
        "headline": "Vermont to pay up to $10K to new residents who work remotely",
        "abstract": "Vermont's governor has signed into law a bill that will pay new residents who work remotely for an out-of-state employer up to $10,000, an effort to attract younger people.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Vermont to pay up to $10K to new residents who work remotely",
          "isclickable": true,
          "abstract": "Vermont's governor has signed into law a bill that will pay new residents who work remotely for an out-of-state employer up to $10,000, an effort to attract younger people."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T15:23:41Z",
        "lastEditedDate": "2018-06-01T21:18:17Z",
        "publishedDate": "2018-06-01T15:23:41Z",
        "updatedDate": "2018-06-01T21:17:24Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T11:23:41.0000000",
          "lastedited": "2018-06-01T17:18:17.0000000",
          "published": "2018-06-01T11:23:41.0000000",
          "updated": "2018-06-01T17:17:24.0000000"
        },
        "seo": {
          "description": "By STEPHANIE MORALES Associated Press",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "vermont-to-pay-up-to-10k-to-new-residents-who-work-remotely",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38329450/yellowstone-park-boss-says-retirement-isnt-tied-to-politics",
        "id": 38329450,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN05",
          "dateTime": "2018-06-01T17:18:06Z"
        },
        "headline": "Yellowstone park boss says retirement isn't tied to politics",
        "abstract": "Yellowstone National Park's superintendent says he plans to retire next year but dismissed speculation that the Trump administration pushed him out for political reasons.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Yellowstone park boss says retirement isn't tied to politics",
          "isclickable": true,
          "abstract": "Yellowstone National Park's superintendent says he plans to retire next year but dismissed speculation that the Trump administration pushed him out for political reasons.",
          "abstractimage": {
            "filename": "http://images.worldnow.com/AP/images/16893034_G.jpg",
            "width": 90,
            "location": "LEFT",
            "caption": "(AP Photo/Pablo Martinez Monsivais,File). FILE - This March 23, 2015 file photo shows Head of the National Park Foundation Dan Wenk, at the World War II Memorial on the National Mall in Washington. Wenk, who has been superintendent of Yellowstone since...",
            "lastediteddate": "2018-06-01T17:17:15.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://images.worldnow.com/AP/images/16893034_G.jpg",
          "width": 90,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T17:17:15.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T21:17:14Z",
        "lastEditedDate": "2018-06-01T21:18:06Z",
        "publishedDate": "2018-06-01T21:17:14Z",
        "updatedDate": "2018-06-01T21:17:16Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T17:17:14.0000000",
          "lastedited": "2018-06-01T17:18:06.0000000",
          "published": "2018-06-01T17:17:14.0000000",
          "updated": "2018-06-01T17:17:16.0000000"
        },
        "seo": {
          "description": "Yellowstone National Park's superintendent said Friday that he plans to retire next year from a job he called \"the best in the National Park Service\" and dismissed speculation that the...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "yellowstone-park-boss-says-retirement-isnt-tied-to-politics",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38329381/missouri-report-blacks-85-percent-more-likely-to-be-stopped",
        "id": 38329381,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN03",
          "dateTime": "2018-06-01T17:12:11Z"
        },
        "headline": "Missouri report: Blacks 85 percent more likely to be stopped",
        "abstract": "Nearly four years after protests in Ferguson raised concerns about racial profiling of blacks in Missouri, a report from the state attorney general shows that African-American drivers are 85 percent more likely to be pulled over than whites.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Missouri report: Blacks 85 percent more likely to be stopped",
          "isclickable": true,
          "abstract": "Nearly four years after protests in Ferguson raised concerns about racial profiling of blacks in Missouri, a report from the state attorney general shows that African-American drivers are 85 percent more likely to..."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T21:07:11Z",
        "lastEditedDate": "2018-06-01T21:12:11Z",
        "publishedDate": "2018-06-01T21:07:11Z",
        "updatedDate": "2018-06-01T21:11:38Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T17:07:11.0000000",
          "lastedited": "2018-06-01T17:12:11.0000000",
          "published": "2018-06-01T17:07:11.0000000",
          "updated": "2018-06-01T17:11:38.0000000"
        },
        "seo": {
          "description": "Nearly four years after protests in Ferguson raised concerns about racial profiling of blacks in Missouri, a report from the state attorney general shows that African-American drivers are 85...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "missouri-report-blacks-85-percent-more-likely-to-be-stopped",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38323215/outgoing-missouri-governor-signs-revenge-porn-law",
        "id": 38323215,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-06-01T17:12:09Z"
        },
        "headline": "Outgoing Missouri governor signs 'revenge porn' law",
        "abstract": "Missouri is getting a new leader as its scandal-plagued governor steps down, elevating the lieutenant governor to the top job.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Outgoing Missouri governor signs 'revenge porn' law",
          "isclickable": true,
          "abstract": "Missouri is getting a new leader as its scandal-plagued governor steps down, elevating the lieutenant governor to the top job.",
          "abstractimage": {
            "filename": "http://images.worldnow.com/AP/images/16887309_G.jpg",
            "width": 90,
            "location": "LEFT",
            "caption": "(Robert Cohen/St. Louis Post-Dispatch via AP). Missouri Gov. Eric Greitens leaves the podium after announcing his resignation in the governor's office, Tuesday, May 29, 2018, in Jefferson City, Mo. Greitens resigned amid a widening investigation that a...",
            "lastediteddate": "2018-06-01T00:17:07.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://images.worldnow.com/AP/images/16887309_G.jpg",
          "width": 90,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T00:17:07.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T04:17:06Z",
        "lastEditedDate": "2018-06-01T21:12:08Z",
        "publishedDate": "2018-06-01T04:17:06Z",
        "updatedDate": "2018-06-01T21:11:31Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T00:17:06.0000000",
          "lastedited": "2018-06-01T17:12:08.0000000",
          "published": "2018-06-01T00:17:06.0000000",
          "updated": "2018-06-01T17:11:31.0000000"
        },
        "seo": {
          "description": "Hours before he was to leave office, Missouri Gov. Eric Greitens on Friday signed into law a measure that makes it a crime to try to blackmail a person using a private sexual image - the same...",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "outgoing-missouri-governor-signs-revenge-porn-law",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38327282/unlikely-visitor-rev-graham-campaigns-in-liberal-berkeley",
        "id": 38327282,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-06-01T17:12:03Z"
        },
        "headline": "Unlikely visitor, Rev. Graham campaigns in liberal Berkeley",
        "abstract": "The Rev. Franklin Graham says he is coming to Berkeley in peace _ and in a longshot attempt to sway some voters to support evangelic Christian candidates.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Unlikely visitor, Rev. Graham campaigns in liberal Berkeley",
          "isclickable": true,
          "abstract": "The Rev. Franklin Graham says he is coming to Berkeley in peace _ and in a longshot attempt to sway some voters to support evangelic Christian candidates.",
          "abstractimage": {
            "filename": "http://images.worldnow.com/AP/images/16891074_G.jpg",
            "width": 90,
            "location": "LEFT",
            "caption": "(AP Photo/Hau Dinh, File). FILE - In this Friday, Dec. 8, 2017, file photo, evangelical preacher Franklin Graham speaks in Hanoi, Vietnam. Graham says he is coming to Berkeley, Calif., Friday, June 1, 2018, in peace and in a longshot attempt to sway s...",
            "lastediteddate": "2018-06-01T12:47:16.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://images.worldnow.com/AP/images/16891074_G.jpg",
          "width": 90,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T12:47:16.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T16:47:16Z",
        "lastEditedDate": "2018-06-01T21:12:03Z",
        "publishedDate": "2018-06-01T16:47:16Z",
        "updatedDate": "2018-06-01T21:11:25Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T12:47:16.0000000",
          "lastedited": "2018-06-01T17:12:03.0000000",
          "published": "2018-06-01T12:47:16.0000000",
          "updated": "2018-06-01T17:11:25.0000000"
        },
        "seo": {
          "description": "The Rev. Franklin Graham says he is coming to Berkeley in peace and in a longshot attempt to sway voters to support evangelical Christian candidates.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "unlikely-visitor-rev-graham-campaigns-in-liberal-berkeley",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38326578/judge-agrees-to-halt-fetal-heartbeat-abortion-law-in-iowa",
        "id": 38326578,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-06-01T17:11:58Z"
        },
        "headline": "Judge agrees to halt fetal heartbeat abortion law in Iowa",
        "abstract": "Judge says he'll temporarily block most restrictive abortion law in the country from taking effect next month in Iowa.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Judge agrees to halt fetal heartbeat abortion law in Iowa",
          "isclickable": true,
          "abstract": "Judge says he'll temporarily block most restrictive abortion law in the country from taking effect next month in Iowa."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T15:27:21Z",
        "lastEditedDate": "2018-06-01T21:11:57Z",
        "publishedDate": "2018-06-01T15:27:21Z",
        "updatedDate": "2018-06-01T21:11:21Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T11:27:21.0000000",
          "lastedited": "2018-06-01T17:11:57.0000000",
          "published": "2018-06-01T11:27:21.0000000",
          "updated": "2018-06-01T17:11:21.0000000"
        },
        "seo": {
          "description": "An Iowa judge agreed Friday to temporarily block the most restrictive abortion law in the country under an agreement between the state and abortion rights groups.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "judge-agrees-to-halt-fetal-heartbeat-abortion-law-in-iowa",
          "includedate": false
        }
      }, {
        "displaysize": "-1",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38323266/saintly-educator-with-a-dark-side-rev-gets-up-to-26-years",
        "id": 38323266,
        "status": "Live",
        "owner": {
          "id": 153,
          "name": "AP",
          "baseurl": "ap.worldnow.com",
          "enablecommentsonshare": true
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-06-01T17:11:52Z"
        },
        "headline": "Saintly educator with a dark side: 'Rev' gets up to 26 years",
        "abstract": "A former high school dean and anti-violence advocate faces up to 20 years in prison for shooting and nearly killing a student he had recruited to sell marijuana for him.",
        "contentClassification": "News - AP-National",
        "cls": 298,
        "abridged": {
          "headline": "Saintly educator with a dark side: 'Rev' gets up to 26 years",
          "isclickable": true,
          "abstract": "A former high school dean and anti-violence advocate faces up to 20 years in prison for shooting and nearly killing a student he had recruited to sell marijuana for him.",
          "abstractimage": {
            "filename": "http://images.worldnow.com/AP/images/16887375_G.jpg",
            "width": 90,
            "location": "LEFT",
            "caption": "(Pat Greenhouse/The Boston Globe via AP). In this May 30, 2018, photo, Shaun Harrison reacts as attorneys give closing arguments in Suffolk Superior Court in the jury trial of him in Boston. Harrison, the former dean at a Boston high school who was kno...",
            "lastediteddate": "2018-06-01T00:27:22.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://images.worldnow.com/AP/images/16887375_G.jpg",
          "width": 90,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T00:27:22.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": true
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": true
            }
          },
          "socialtools": {
            "comments": {
              "display": true
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T04:27:21Z",
        "lastEditedDate": "2018-06-01T21:11:52Z",
        "publishedDate": "2018-06-01T04:27:21Z",
        "updatedDate": "2018-06-01T21:11:19Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T00:27:21.0000000",
          "lastedited": "2018-06-01T17:11:52.0000000",
          "published": "2018-06-01T00:27:21.0000000",
          "updated": "2018-06-01T17:11:19.0000000"
        },
        "seo": {
          "description": "Shaun Harrison was a Boston high school dean and anti-violence advocate known by students as \"Rev\" for his pastor-like demeanor. But the pious facade hid a dark double life.",
          "robot": "NoIndex,Follow,NoArchive",
          "pageurl": "saintly-educator-with-a-dark-side-rev-gets-up-to-26-years",
          "includedate": false
        }
      }],
      "totalresults": 11
    }
  }, {
    "type": "xmlblock",
    "displaysize": "29",
    "displayorder": "1",
    "isimplicit": false,
    "id": 182796,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2015-12-28T07:20:58Z"
    },
    "headline": "The Great Mini Banners Display",
    "body": "<div id=\"gnmBanners\"></div> <script type=\"text/javascript\"> if(window.location.host !== 'm.newson6.com' && window.location.host !== 'm.news9.com'){ GNM.Banners(); } </script>"
  }, {
    "type": "xmlblock",
    "displaysize": "29",
    "displayorder": "2",
    "isimplicit": false,
    "id": 352388,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN01",
      "dateTime": "2014-08-28T13:47:33Z"
    },
    "headline": "Header: Local News",
    "body": "<h2 class=\"gnmHeader\">News</h2>"
  }, {
    "type": "xmlblock",
    "displaysize": "31",
    "displayorder": "1",
    "isimplicit": false,
    "id": 181991,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN03",
      "dateTime": "2016-12-27T12:17:56Z"
    },
    "headline": "Promo Box: News Col 2/3",
    "body": "<div class=\"wnDVNestedCategory wnDSContainer-standard lifestyles\"> <div class=\"wnDSHeader\"> <h3><span class=\"\">Special Features</span> <div style=\"clear: both;\"></div> </h3> </div> <!--END wnDSHeader--> <div class=\"wnDSItems-standard\"> <div class=\"wnDS-7\"> <div class=\"wnDVSummary\"> <div class=\"wnImage wnImageLeft\"> <a href=\"/category/296298/news-on-6-traffic-map\"><img src=\"http://ftpcontent.worldnow.com/kotv/custom/promobox/traffic_114x64.jpg\"></a> </div> <h4 class=\"wnRole-STORY\"><a href=\"/category/296298/news-on-6-traffic-map\">Live Traffic</a></h4> <p>Get the latest road conditions on Green Country roadways.</p> </div> <!--END wnDVSummary--> <div class=\"wnDVSummary\"> <div class=\"wnImage wnImageLeft\"> <a href=\"http://itunes.apple.com/us/app/news-on-6-oklahomas-own/id405727120?mt=8\" target=\"_blank\"><img src=\"http://ftpcontent.worldnow.com/kotv/custom/promoboxes/2_3/iPhone-6_180x101.jpg\"></a> </div> <h4 class=\"wnRole-STORY\"><a href=\"http://itunes.apple.com/us/app/news-on-6-oklahomas-own/id405727120?mt=8\" target=\"_blank\">iPhone App</a></h4> <p>Get breaking news, weather, sports &amp; video directly on your iPhone.</p> </div> <!--END wnDVSummary--> <div class=\"wnDVSummary\"> <div class=\"wnImage wnImageLeft\"> <a href=\"/Global/link.asp?L=288387\"><img src=\"http://ftpcontent.worldnow.com/kotv/custom/promobox/tvProgramming114x64.jpg\"></a> </div> <h4 class=\"wnRole-STORY\"><a href=\"/Global/link.asp?L=288387\">CBS Shows</a></h4> <p>Watch your favorite CBS shows for free online.</p> </div> <!--END wnDVSummary--> <div class=\"wnDVSummary\"> <div class=\"wnImage wnImageLeft\"> <a href=\"/category/120897/the-news-on-6-featured-links\"><img src=\"http://ftpcontent.worldnow.com/kotv/custom/promoboxes/2_3/links114x64.jpg\"></a> </div> <h4 class=\"wnRole-STORY\"><a href=\"/category/120198/links-mentioned-on-news-9\">Links</a></h4> <p>Looking for a website or event you heard mentioned on News On 6? Find it here!</p> </div> <!--END wnDVSummary--> <div class=\"wnDVSummary\"> <div class=\"wnImage wnImageLeft\"> <a href=\"/story/11777977/tv-programming-schedule\"><img src=\"http://ftpcontent.worldnow.com/kotv/custom/promoboxes/2_3/tvProgramming114x64.jpg\"></a> </div> <h4 class=\"wnRole-STORY\"><a href=\"/story/11777977/tv-programming-schedule\">TV Schedule</a></h4> <p>Need to know what's on TV? Check out our television schedule.</p> </div> <!--END wnDVSummary--> </div> <!--END Nested Display Size: wnDS-7--> </div> <!--END wnDSItems--> </div> <!--END wnDVContentGroup-->"
  }, {
    "type": "xmlblock",
    "displaysize": "31",
    "displayorder": "99",
    "isimplicit": false,
    "id": 183199,
    "status": "Live",
    "targeting": 0,
    "build": {
      "machinename": "NJTASKRUN02",
      "dateTime": "2014-02-28T10:06:29Z"
    },
    "headline": "The Great News Nested Category Enforcer",
    "body": "<style type=\"text/css\"> #WNDS7 .wnDSItems-contentgroup { overflow:hidden; margin-bottom:20px; } #WNDS7 .wnDVNestedCategory { width:324px; float:left; } #WNDS7 .wnDVNestedCategory:first-child { margin-right:15px; } .nestedCategory .wnGroup { width:324px; float:left; } .nestedCategory .wnGroup:first-child { margin-right:16px; } </style>"
  }, {
    "type": "form",
    "displaysize": "64",
    "displayorder": "1",
    "isimplicit": false,
    "formno": 24736,
    "status": "Live",
    "build": {
      "machinename": "NJTASKRUN01",
      "dateTime": "2016-06-13T17:06:47Z"
    },
    "headline": "News On 6 News Tips",
    "abstract": "",
    "contentClassification": "News",
    "footer": "<p>Thank you for your tip.</p>",
    "landingpagetype": 0,
    "allowmultipleentries": 1,
    "requireregistration": false,
    "quickfields": {
      "isquickformcomplete": 1,
      "profileelement": {
        "name": "Zip Code",
        "value": "ZipCode",
        "required": 1,
        "type": 1
      },
      "questions": [{
        "type": "question",
        "text": "Do you have a news tip for The News On 6? Enter it here.",
        "required": 1,
        "answers": {
          "textarea": ""
        },
        "displayorder": 1
      }, {
        "type": "question",
        "text": "Phone number:",
        "required": 0,
        "answers": {
          "input": ""
        },
        "displayorder": 1
      }]
    }
  }, {
    "type": "xmlblock",
    "displaysize": "64",
    "displayorder": "2",
    "isimplicit": false,
    "id": 325172,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN02",
      "dateTime": "2014-03-10T19:51:48Z"
    },
    "headline": "Taboola Right Rail - KOTV News",
    "body": "<div id=\"taboolaRightRail\" style=\"margin-bottom:20px;\"> <div id='taboola-right-rail-mix'></div> </div> <script type=\"text/javascript\"> $(function(){ $('#taboolaRightRail').insertAfter($('#WNAd43')); window._taboola = window._taboola || []; _taboola.push({mode:'thumbs-2r-rrcp', container:'taboola-right-rail-mix', placement:'right-rail', target_type:'mix'}); _taboola.push({article:'auto'}); _taboola.push({flush:true}); }); </script>"
  }, {
    "type": "xmlblock",
    "displaysize": "66",
    "displayorder": "86",
    "isimplicit": false,
    "id": 234286,
    "status": "Live",
    "targeting": 0,
    "build": {
      "machinename": "NJTASKRUN03",
      "dateTime": "2013-07-17T17:48:15Z"
    },
    "headline": "The Great Fifteen Minute Page Refresher",
    "body": "<script type=\"text/javascript\"> var pageRefresher = setTimeout(function() { try { window.location.reload(true); } catch(err) {} }, 900000); </script>"
  }, {
    "type": "xmlblock",
    "displaysize": "66",
    "displayorder": "99",
    "isimplicit": false,
    "id": 183108,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN04",
      "dateTime": "2018-02-06T13:44:36Z"
    },
    "headline": "Archive Calendar - Shove",
    "body": "<style type=\"text/css\"> .gnmCalendar { width:325px !important; background:#f5f5f5; margin-bottom:15px; } #WNCol4 .gnmCalendar { width:300px !important; } .gnmCalendar .calendar { width:100%; } .gnmCalendar .calendar th { background:#666; color:#fff; font:bold 14px sans-serif !important; } .gnmCalendar h3 { padding:10px 0; background:#fff; border-top:1px solid #ccc; border-bottom:1px solid #ccc; } .gnmCalendar .controls { position:relative; font:bold 14px sans-serif !important; padding:3px 0; } .gnmCalendar .controls a { display:block; width:16px; height:0; padding:16px 0 0; overflow:hidden; position:absolute; top:3px; background:url(\"http://ftpcontent.worldnow.com/kotv/custom/calendar/cal_arrows.png\") no-repeat; } .gnmCalendar .controls span { text-align:center; display:block; } .gnmCalendar .controls .prev { left:3px; } .gnmCalendar .controls .next { right:3px; background-position:-16px 0; } .gnmCalendar .calendar .day { width:14%; height:27px; text-align:center; background:#ccc; font:12px sans-serif !important; overflow:hidden; } .gnmCalendar .calendar a { color:#000; text-decoration:none; font-weight:bold; display:block; width:100%; height:16px; padding:2px 0 0; } .gnmCalendar .calendar .future { color:#eee; height:26px; } .gnmCalendar .calendar .today { background:#f9cf6c; font-weight:bold; } .gnmCalendar .calendar .past:hover, .gnmCalendar .calendar .today:hover { background:#be0000 !important; cursor:pointer; } .gnmCalendar .calendar .past:hover a, .gnmCalendar .calendar .today:hover a { color:#fff !important; } .gnmCalendar .calSearch { width:300px; padding:5px; } .gnmCalendar .calSearch input { width:200px; margin-right:10px; } .gnmCalendar .calSearch button { width:80px; } </style> <div id=\"calendar\" class=\"shoved\"></div> <script type=\"text/javascript\"> $(function() { GNM.archiveCalendar('#calendar'); }); </script>"
  }, {
    "type": "xmlblock",
    "displaysize": "76",
    "displayorder": "1",
    "isimplicit": false,
    "id": 182791,
    "status": "Live",
    "targeting": 1,
    "build": {
      "machinename": "NJTASKRUN04",
      "dateTime": "2018-05-01T12:37:29Z"
    },
    "headline": "The Great Col4 Weather Feature Display -- DO NOT DELETE --",
    "body": "<style> #col4wxsub { height:auto; width:300px; padding:0; margin:0; display:none; } #col4wxsub span { color: #BE0000 !important; padding-left:5px; } #col4wxsub img { padding:5px; background-color:white; border:1px solid #EBEBEB; height:185px; width:300px; } </style> <div id=\"col4wxsub\"> <h3 class=\"gHead\">Live Radar</h3> <a id=\"radarImageAnchor\" href=\"/category/158741/warn-interactive-live-radar?redirected=true\" title=\"Warn Interactive Radar\"><img id=\"radarImage\" src=\"http://aws.kotv.com/kotv/ssite/320x225/statewide_anim.gif\" alt=\"WARN Interactive\" /></a> </div> <div id=\"wx4\"> <div class=\"infos\"></div> <div id=\"modalmsg\" class=\"modal\"> <div class=\"modalbox\"> <span></span> <button>OK</button> </div> </div> <div id=\"modalzip\" class=\"modal\"> <div class=\"modalbox\"> <label for=\"zipinput\">Customize Your Forecast:</label> <input id=\"zipinput\" type=\"text\" placeholder=\"Zip Code\" /> <button id=\"ziplookup\">Lookup</button> <a href=\"#\" id=\"modalx\"></a> </div> </div> </div> <script type=\"text/javascript\"> var GNM = GNM || {}; $(function() { var isKOTV = window.location.hostname.split('.')[1] === 'newson6'; var radarImage = $('#radarImage'); var radarImageAnchor = $('#radarImageAnchor'); var radarObj = { site: isKOTV ? '1' : '2', zip: isKOTV ? '74120' : '73179', station: isKOTV ? 'kotv' : 'kwtv', url: isKOTV ? 'http://www.newson6.com/Global/category.asp?C=158741' : 'http://www.news9.com/Global/category.asp?C=158742', imageAlt: isKOTV ? 'WARN Interactive' : 'ESP Interactive', anchorTitle: isKOTV ? 'Warn Interactive Radar' : 'ESP Interactive Radar', radarImgUrl: isKOTV ? '/category/158741/warn-interactive-live-radar?redirected=true' : '/category/158742/interactive-esp-radar?redirected=true' }; radarImage.attr('src', 'http://aws.kotv.com/' + radarObj.station + '/ssite/320x225/statewide_anim.gif'); radarImage.attr('alt', radarObj.imageAlt); radarImageAnchor.attr('href', radarObj.radarImgUrl); radarImageAnchor.attr('title', radarObj.anchorTitle); var TIMEOUT_PERIOD = 5000, useBackup = false, loadTimer = null, loadCheck = function() { if ($('#wx4 .infos img').length == 0) { $('#wx4').hide(); $('#col4wxsub').show(); } }; if (useBackup) { $('#wx4').hide(); $('#col4wxsub').show(); } else { GNM.wx4({ zip: radarObj.zip, feed: 'http://kotv.com/api/GetForecast.ashx?site=' + radarObj.site + '&action=Column4&zip=', radarImg: 'http://aws.kotv.com/' + radarObj.station + '/ssite/196x110/main_anim.gif', radarUrl: radarObj.url }); loadTimer = setTimeout(loadCheck, TIMEOUT_PERIOD); } }); </script>"
  }, {
    "displaysize": "80",
    "displayorder": "3",
    "isimplicit": false,
    "type": "category",
    "link": "http://www.newson6.com/category/175087/6-investigates",
    "id": 175087,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "IIS23",
      "dateTime": "2018-04-24T19:20:02Z"
    },
    "iscontrolledcategory": false,
    "isHomeCategory": false,
    "headline": "6 Investigates",
    "abstract": "Are you aware of incidents of fraud? Corruption? Government waste? Submit a confidential news tip!",
    "contentClassification": "Sales - WorldNow 22",
    "cls": 280,
    "lastediteddate": "2013-01-31T19:45:06Z",
    "creationDate": "2009-09-16T20:03:24Z",
    "datetime": {
      "created": "2009-09-16T16:03:24.0000000",
      "lastedited": "2013-01-31T14:45:06.0000000"
    },
    "abridged": {
      "headline": "6 Investigates",
      "isclickable": true
    },
    "seo": {
      "robot": "Index,Follow,NoArchive",
      "pageurl": "6-investigates"
    },
    "nested": {
      "features": [{
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/34913421/6-investigates-staffer-alleges-widespread-sexual-harassment-at-state-capitol",
        "id": 34913421,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T12:01:55Z"
        },
        "headline": "6 Investigates: Staffer Alleges Widespread Sexual Harassment At State Capitol",
        "abstract": "<p>Fear of retaliation, explicit texts, requests for topless pictures are all allegations made this year against Oklahoma lawmakers. But one aid says problems go even deeper.</p>",
        "contentClassification": "News",
        "cls": 3,
        "abridged": {
          "headline": "6 Investigates: Staffer Alleges Widespread Sexual Harassment At State Capitol",
          "isclickable": true,
          "abstract": "<p>Fear of retaliation, explicit texts, requests for topless pictures are all allegations made this year against Oklahoma lawmakers. But one aid says problems go even deeper.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/13392877_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/13392877_G.jpg",
          "width": 250,
          "location": "LEFT"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2017-03-16T03:13:44Z",
        "lastEditedDate": "2017-03-16T03:13:44Z",
        "publishedDate": "2017-03-16T03:13:44Z",
        "updatedDate": "2017-03-16T03:13:44Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2017-03-15T23:13:44.0000000",
          "lastedited": "2017-03-15T23:13:44.0000000",
          "published": "2017-03-15T23:13:44.0000000",
          "updated": "2017-03-15T23:13:44.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 13178006,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2017-03-16T03:28:45.353Z"
        }],
        "seo": {
          "browsertitle": "6 Investigates: Staffer Alleges Widespread Sexual Harassment At",
          "description": "Fear of retaliation, explicit texts, requests for topless pictures are all allegations made this year against Oklahoma lawmakers. But one aid says problems go even deeper.",
          "pageurl": "6-investigates-staffer-alleges-widespread-sexual-harassment-at-state-capitol",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "OKLAHOMA CITY, Oklahoma"
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/33777563/6-investigates-schools-arming-teachers-to-protect-students",
        "id": 33777563,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T12:01:34Z"
        },
        "headline": "6 Investigates: Schools Arming Teachers To Protect Students",
        "abstract": "<p>A gun-free zone is a target, that's the rationale behind a law to make our schools safer. It was approved by state lawmakers last year.</p>",
        "contentClassification": "Sales - WorldNow 22",
        "cls": 280,
        "abridged": {
          "headline": "6 Investigates: Schools Arming Teachers To Protect Students",
          "isclickable": true,
          "abstract": "<p>A gun-free zone is a target, that's the rationale behind a law to make our schools safer. It was approved by state lawmakers last year.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/12533412_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/12533412_G.jpg",
          "width": 250,
          "location": "LEFT"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-11-23T04:16:18Z",
        "lastEditedDate": "2016-11-23T17:38:51Z",
        "publishedDate": "2016-11-23T04:16:18Z",
        "updatedDate": "2016-11-23T17:38:51Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-11-22T23:16:18.0000000",
          "lastedited": "2016-11-23T12:38:51.0000000",
          "published": "2016-11-22T23:16:18.0000000",
          "updated": "2016-11-23T12:38:51.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12918931,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-11-23T04:37:36.353Z"
        }],
        "seo": {
          "description": "A gun-free zone is a target, that's the rationale behind a law to make our schools safer. It was approved by state lawmakers last year.",
          "pageurl": "6-investigates-schools-arming-teachers-to-protect-students",
          "shorturl": "http://bit.ly/2f75ny0",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Alex",
          "lastname": "Cameron",
          "title": "6 Investigates",
          "link": "/story/11114943/alex-cameron-oklahoma-impact-team",
          "emailaddress": "alex.cameron@news9.net"
        }],
        "dateline": "DRUMRIGHT, Oklahoma"
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/32189865/6-investigates-hire-education",
        "id": 32189865,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T11:59:28Z"
        },
        "headline": "6 Investigates: 'Hire' Education",
        "abstract": "<p>At a time when most government agencies have been attempting to cap their workforces, if not reduce them, state-supported higher education is doing just the opposite.</p>",
        "contentClassification": "Education",
        "cls": 26,
        "abridged": {
          "headline": "6 Investigates: 'Hire' Education",
          "isclickable": true,
          "abstract": "<p>At a time when most government agencies have been attempting to cap their workforces, if not reduce them, state-supported higher education is doing just the opposite.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/10747563_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/10747563_G.jpg",
          "width": 250,
          "location": "LEFT"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-06-10T02:36:28Z",
        "lastEditedDate": "2016-06-10T03:00:21Z",
        "publishedDate": "2016-06-10T02:36:28Z",
        "updatedDate": "2016-06-10T03:00:21Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-06-09T22:36:28.0000000",
          "lastedited": "2016-06-09T23:00:21.0000000",
          "published": "2016-06-09T22:36:28.0000000",
          "updated": "2016-06-09T23:00:21.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12511420,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-06-10T03:33:03.270Z"
        }],
        "seo": {
          "description": "At a time when most government agencies have been attempting to cap their workforces, if not reduce them, state-supported higher education is doing just the opposite.",
          "pageurl": "6-investigates-hire-education",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Alex",
          "lastname": "Cameron",
          "title": "6 Investigates",
          "link": "/story/11114943/alex-cameron-oklahoma-impact-team",
          "emailaddress": "alex.cameron@news9.net"
        }]
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/31788982/9-investigates-inspecting-oklahoma-meat-farms",
        "id": 31788982,
        "status": "Live",
        "owner": {
          "id": 690,
          "name": "KWTV",
          "baseurl": "www.news9.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T11:45:35Z"
        },
        "headline": "9 Investigates: Inspecting Oklahoma Meat Farms",
        "abstract": "<p>Agriculture may not play the role it once did in the Oklahoma economy, but in rural northwest Oklahoma, it still matters.&nbsp;</p>",
        "contentClassification": "Station 22",
        "cls": 362,
        "abridged": {
          "headline": "9 Investigates: Inspecting Oklahoma Meat Farms",
          "isclickable": true,
          "abstract": "<p>Agriculture may not play the role it once did in the Oklahoma economy, but in rural northwest Oklahoma, it still matters.&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KWTV.images.worldnow.com/images/10385512_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KWTV.images.worldnow.com/images/10385512_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "There is a contingent of Oklahomans who believe these farms -- concentrated animal feeding operations, or CAFO's -- pose a public health risk because they are under-regulated."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-04-22T02:54:47Z",
        "lastEditedDate": "2016-04-22T02:54:47Z",
        "publishedDate": "2016-04-22T02:54:47Z",
        "updatedDate": "2016-04-22T02:54:47Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-04-21T22:54:47.0000000",
          "lastedited": "2016-04-21T22:54:47.0000000",
          "published": "2016-04-21T22:54:47.0000000",
          "updated": "2016-04-21T22:54:47.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12381292,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-04-22T03:47:13.730Z"
        }],
        "seo": {
          "keywords": "Animals, farms, CAFO, Oklahoma, agriculture, 9 investigates, okc, news 9, kwtv",
          "description": "Agriculture may not play the role it once did in the Oklahoma economy, but in rural northwest Oklahoma, it still matters. ",
          "pageurl": "9-investigates-inspecting-oklahoma-meat-farms",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By",
          "firstname": "Alex",
          "lastname": "Cameron",
          "title": "9 Investigates",
          "link": "/story/11114943/alex-cameron-oklahoma-impact-team",
          "emailaddress": "alex.cameron@news9.net"
        }],
        "dateline": "OKLAHOMA CITY",
        "topics": [{
          "type": "topic",
          "value": "Animals"
        }]
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/31605843/new-video-shows-former-reserve-deputy-using-force-days-before-harris-shooting",
        "id": 31605843,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T12:00:44Z"
        },
        "headline": "New Video Shows Former Reserve Deputy Using Force Days Before Harris Shooting",
        "abstract": "<p>New video shows a former Tulsa County reserve deputy on duty, using force, days before he shot and killed a suspect.</p>",
        "contentClassification": "Sales - WorldNow 22",
        "cls": 280,
        "abridged": {
          "headline": "New Video Shows Former Reserve Deputy Using Force Days Before Harris Shooting",
          "isclickable": true,
          "abstract": "<p>New video shows a former Tulsa County reserve deputy on duty, using force, days before he shot and killed a suspect.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/10222704_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/10222704_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "Reserve Deputy Bob Bates."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-03-31T03:08:04Z",
        "lastEditedDate": "2016-04-02T03:20:02Z",
        "publishedDate": "2016-03-31T03:08:04Z",
        "updatedDate": "2016-04-02T03:20:02Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-03-30T23:08:04.0000000",
          "lastedited": "2016-04-01T23:20:02.0000000",
          "published": "2016-03-30T23:08:04.0000000",
          "updated": "2016-04-01T23:20:02.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12329220,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-04-01T01:08:17.380Z"
        }],
        "seo": {
          "browsertitle": "New Video Shows Former Reserve Deputy Using Force Days Before Ha",
          "description": "New video shows a former Tulsa County reserve deputy on duty, using force, days before he shot and killed a suspect.",
          "pageurl": "new-video-shows-former-reserve-deputy-using-force-days-before-harris-shooting",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Ziva",
          "lastname": "Branstetter",
          "title": "The Frontier"
        }],
        "dateline": "TULSA COUNTY, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/31383261/news-on-6-tours-jail-at-center-of-civil-lawsuit-against-former-sheriff",
        "id": 31383261,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T11:58:52Z"
        },
        "headline": "News On 6 Tours Jail At Center Of Civil Lawsuit Against Former Sheriff",
        "abstract": "<p>A jury found in favor of a former juvenile inmate in a civil rights lawsuit against a former Tulsa County sheriff. Thursday, News On 6 took a tour of the jail to see what has changed.</p>",
        "contentClassification": "Sales - WorldNow 22",
        "cls": 280,
        "abridged": {
          "headline": "News On 6 Tours Jail At Center Of Civil Lawsuit Against Former Sheriff",
          "isclickable": true,
          "abstract": "A jury found in favor of a former juvenile inmate in a civil rights lawsuit against a former Tulsa County sheriff. Thursday, News On 6 took a tour of the jail to see what has changed.",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/10024940_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/10024940_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "Back in 2010, there were no cameras in the unit, and there were curtains blocking a line of vision to the girls' cells."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-03-04T04:34:37Z",
        "lastEditedDate": "2016-03-04T04:34:37Z",
        "publishedDate": "2016-03-04T04:34:37Z",
        "updatedDate": "2016-03-04T04:34:37Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-03-03T23:34:37.0000000",
          "lastedited": "2016-03-03T23:34:37.0000000",
          "published": "2016-03-03T23:34:37.0000000",
          "updated": "2016-03-03T23:34:37.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12260715,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-03-04T04:44:30.080Z"
        }],
        "seo": {
          "browsertitle": "News On 6 Tours Jail At Center Of Civil Lawsuit Against Former S",
          "description": "A jury found in favor of a former juvenile inmate in a civil rights lawsuit against a former Tulsa County sheriff. Thursday, News On 6 took a tour of the jail to see what has changed.",
          "pageurl": "news-on-6-tours-jail-at-center-of-civil-lawsuit-against-former-sheriff",
          "includedate": false
        },
        "dateline": "TULSA COUNTY, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/31146913/6-investigates-state-hiring-freeze-exemptions",
        "id": 31146913,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "CMSAPI01",
          "dateTime": "2017-09-25T11:58:46Z"
        },
        "headline": "6 Investigates: State Hiring Freeze Exemptions",
        "abstract": "<p>In the wake of a hiring and salary freeze imposed by Governor Fallin one year ago, state agency heads were allowed to continue making hires and giving raises, as if there was no freeze.</p>",
        "contentClassification": "Sales - WorldNow 22",
        "cls": 280,
        "abridged": {
          "headline": "6 Investigates: State Hiring Freeze Exemptions",
          "isclickable": true,
          "abstract": "In the wake of a hiring and salary freeze imposed by Governor Fallin one year ago, state agency heads were allowed to continue making hires and giving raises, as if there was no freeze.",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/9809804_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/9809804_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "News On 6 speaks with Governor Mary Fallin."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-02-05T05:07:08Z",
        "lastEditedDate": "2016-02-05T05:07:08Z",
        "publishedDate": "2016-02-05T05:07:08Z",
        "updatedDate": "2016-02-05T05:07:08Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-02-05T00:07:08.0000000",
          "lastedited": "2016-02-05T00:07:08.0000000",
          "published": "2016-02-05T00:07:08.0000000",
          "updated": "2016-02-05T00:07:08.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12191821,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-02-05T05:47:31.197Z"
        }],
        "seo": {
          "description": "In the wake of a hiring and salary freeze imposed by Governor Fallin one year ago, state agency heads were allowed to continue making hires and giving raises, as if there was no freeze.",
          "pageurl": "6-investigates-state-hiring-freeze-exemptions",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Alex",
          "lastname": "Cameron",
          "title": "6 Investigates",
          "link": "/story/11114943/alex-cameron-oklahoma-impact-team",
          "emailaddress": "alex.cameron@news9.net"
        }],
        "dateline": "OKLAHOMA CITY, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/31018110/6-investigates-tcso-routinely-behind-in-paying-jail-utility-bills",
        "id": 31018110,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2017-11-26T08:00:08Z"
        },
        "headline": "6 Investigates: TCSO Routinely Behind In Paying Jail Utility Bills",
        "abstract": "<p>The Tulsa County Jail has risked having its utilities cut off a dozen times. Records obtained by News On 6 show the sheriff's office is repeatedly late paying utility bills.</p>",
        "contentClassification": "News",
        "cls": 3,
        "abridged": {
          "headline": "6 Investigates: TCSO Routinely Behind In Paying Jail Utility Bills",
          "isclickable": true,
          "abstract": "The Tulsa County Jail has risked having its utilities cut off a dozen times. Records obtained by News On 6 show the sheriff's office is repeatedly late paying utility bills.",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/9694656_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/9694656_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "The sheriff's office is supposed to pay City of Tulsa utility bills for water, sewer and stormwater, and it does - late."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-01-21T04:27:15Z",
        "lastEditedDate": "2016-01-21T04:27:15Z",
        "publishedDate": "2016-01-21T04:27:16Z",
        "updatedDate": "2016-01-21T04:27:15Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-01-20T23:27:15.0000000",
          "lastedited": "2016-01-20T23:27:15.0000000",
          "published": "2016-01-20T23:27:16.0000000",
          "updated": "2016-01-20T23:27:15.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12155277,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-01-21T15:08:31.030Z"
        }],
        "seo": {
          "browsertitle": "6 Investigates: TCSO Routinely Behind In Paying Jail Utility Bil",
          "description": "The Tulsa County Jail has risked having its utilities cut off a dozen times. Records obtained by News On 6 show the sheriff's office is repeatedly late paying utility bills.",
          "pageurl": "6-investigates-tcso-routinely-behind-in-paying-jail-utility-bills",
          "includedate": false
        },
        "dateline": "TULSA COUNTY, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/30914498/dangerous-rigs-oilfield-truck-crashes-kill-injure-dozens",
        "id": 30914498,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2017-11-26T06:48:11Z"
        },
        "headline": "Dangerous Rigs: Oilfield Truck Crashes Kill, Injure Dozens",
        "abstract": "<p>An investigation by News On 6 and our partner, The Frontier, found that about seven percent of the trucking companies licensed for the work have been involved in deadly accidents.</p>",
        "contentClassification": "News",
        "cls": 3,
        "abridged": {
          "headline": "Dangerous Rigs: Oilfield Truck Crashes Kill, Injure Dozens",
          "isclickable": true,
          "abstract": "<p>An investigation by News On 6 and our partner, The Frontier, found that about seven percent of the trucking companies licensed for the work have been involved in deadly accidents.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/9604362_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/9604362_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "It slammed into his driver's side and pinned him under the truck for over an hour."
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2016-01-08T03:31:14Z",
        "lastEditedDate": "2016-01-08T03:58:17Z",
        "publishedDate": "2016-01-08T03:31:15Z",
        "updatedDate": "2016-01-08T03:58:17Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2016-01-07T22:31:14.0000000",
          "lastedited": "2016-01-07T22:58:17.0000000",
          "published": "2016-01-07T22:31:15.0000000",
          "updated": "2016-01-07T22:58:17.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 12124309,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2016-01-08T04:37:13.787Z"
        }, {
          "type": "Clip",
          "id": 12124094,
          "status": "L",
          "displaysize": 37,
          "displayorder": 2,
          "sortbydate": "2016-01-08T04:51:40.700Z"
        }],
        "seo": {
          "description": "An investigation by News On 6 and our partner, The Frontier, found that about seven percent of the trucking companies licensed for the work have been involved in deadly accidents.",
          "pageurl": "dangerous-rigs-oilfield-truck-crashes-kill-injure-dozens",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Ziva",
          "lastname": "Branstetter",
          "title": "The Frontier"
        }],
        "dateline": "EL RENO, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/30640203/judge-in-open-records-case-recuses-after-request-from-fallins-office",
        "id": 30640203,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS21",
          "dateTime": "2016-01-07T14:03:39Z"
        },
        "headline": "Judge In Open Records Case Recuses After Request From Fallin's Office",
        "abstract": "<p>A judge presiding over a lawsuit seeking records related to a botched execution has recused from the case after a request from Gov. Mary Fallin&rsquo;s office.&nbsp;</p>",
        "contentClassification": "News",
        "cls": 3,
        "abridged": {
          "headline": "Judge In Open Records Case Recuses After Request From Fallin's Office",
          "isclickable": true,
          "abstract": "<p>A judge presiding over a lawsuit seeking records related to a botched execution has recused from the case after a request from Gov. Mary Fallin&rsquo;s office.&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/9366154_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/9366154_G.jpg",
          "width": 250,
          "location": "LEFT"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2015-12-01T17:14:07Z",
        "lastEditedDate": "2016-01-07T18:57:41Z",
        "publishedDate": "2015-12-01T17:14:08Z",
        "updatedDate": "2016-01-07T18:57:41Z",
        "sortbydatetype": "LastEdited",
        "seo": {
          "browsertitle": "Judge In Open Records Case Recuses After Request From Fallin's O",
          "description": "A judge presiding over a lawsuit seeking records related to a botched execution has recused from the case after a request from Gov. Mary Fallin’s office. ",
          "pageurl": "judge-in-open-records-case-recuses-after-request-from-fallins-office",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Ziva",
          "lastname": "Branstetter",
          "title": "The Frontier"
        }]
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/30711521/6-investigates-emergency-teacher-certifications-increasing-in-oklahoma",
        "id": 30711521,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS10",
          "dateTime": "2018-04-24T03:20:08Z"
        },
        "headline": "6 Investigates: Emergency Teacher Certifications Increasing In Oklahoma",
        "abstract": "<p>The state's increasing reliance on emergency certified teachers to fill classrooms raises the questions of who these people are and what qualifications do they have?</p>",
        "contentClassification": "News",
        "cls": 3,
        "abridged": {
          "headline": "6 Investigates: Emergency Teacher Certifications Increasing In Oklahoma",
          "isclickable": true,
          "abstract": "The state's increasing reliance on emergency certified teachers to fill classrooms raises the questions of who these people are and what qualifications do they have?",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/9429035_G.jpg",
            "width": 115,
            "location": "LEFT"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/9429035_G.jpg",
          "width": 250,
          "location": "LEFT"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2015-12-10T04:12:10Z",
        "lastEditedDate": "2015-12-10T04:12:10Z",
        "publishedDate": "2015-12-10T04:12:10Z",
        "updatedDate": "2015-12-10T04:12:10Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2015-12-09T23:12:10.0000000",
          "lastedited": "2015-12-09T23:12:10.0000000",
          "published": "2015-12-09T23:12:10.0000000",
          "updated": "2015-12-09T23:12:10.0000000"
        },
        "seo": {
          "browsertitle": "6 Investigates: Emergency Teacher Certifications Increasing In O",
          "description": "The state's increasing reliance on emergency certified teachers to fill classrooms raises the questions of who these people are and what qualifications do they have?",
          "pageurl": "6-investigates-emergency-teacher-certifications-increasing-in-oklahoma",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "Alex",
          "lastname": "Cameron",
          "title": "6 Investigates",
          "link": "/story/11114943/alex-cameron-oklahoma-impact-team",
          "emailaddress": "alex.cameron@news9.net"
        }],
        "dateline": "OKLAHOMA CITY, Oklahoma"
      }],
      "totalresults": 11
    }
  }, {
    "displaysize": "80",
    "displayorder": "4",
    "isimplicit": false,
    "type": "category",
    "link": "http://www.newson6.com/category/161867/crime",
    "id": 161867,
    "status": "Live",
    "owner": {
      "id": 691,
      "name": "KOTV",
      "baseurl": "www.newson6.com",
      "enablecommentsonshare": false
    },
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T17:10:57Z"
    },
    "iscontrolledcategory": false,
    "isHomeCategory": false,
    "headline": "Crime",
    "abstract": "",
    "contentClassification": "Crime",
    "cls": 566,
    "lastediteddate": "2016-03-29T19:44:31Z",
    "creationDate": "2009-03-02T16:15:57Z",
    "datetime": {
      "created": "2009-03-02T11:15:57.0000000",
      "lastedited": "2016-03-29T15:44:31.0000000"
    },
    "abridged": {
      "headline": "Crime",
      "isclickable": true,
      "abstract": "<p>Stay up-to-date on crime stories that affect your life.</p>"
    },
    "seo": {
      "browsertitle": "Crime: The latest Oklahoma crime headlines and safety tips",
      "keywords": "Tulsa news,Oklahoma crimes,crimestoppers,crime stoppers,methamphetamine,Tulsa shooting,Crime Tracker,Lori Fullbright,tulsa crime,crime victim,crimetracker,Oklahoma crime tips,tulsa crime commission",
      "description": "Get the latest Oklahoma crime headlines, safety tips from Lori’s Crime Survival Guide, track crimes with Crime Tracker and help homicide detectives find a murder in Cold Cases.",
      "pageurl": "crime"
    },
    "nested": {
      "features": [{
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38329414/me-okc-couple-strangled-before-being-discovered-in-mcintosh-county",
        "id": 38329414,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-06-01T17:10:42Z"
        },
        "headline": "ME: OKC Couple Strangled Before Being Discovered In McIntosh County",
        "abstract": "<p>As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "ME: OKC Couple Strangled Before Being Discovered In McIntosh County",
          "isclickable": true,
          "abstract": "<p>As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16892982_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T17:09:46.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16892982_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T17:09:46.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T21:10:42Z",
        "lastEditedDate": "2018-06-01T21:10:41Z",
        "publishedDate": "2018-06-01T21:10:42Z",
        "updatedDate": "2018-06-01T21:10:42Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T17:10:42.0000000",
          "lastedited": "2018-06-01T17:10:41.0000000",
          "published": "2018-06-01T17:10:42.0000000",
          "updated": "2018-06-01T17:10:42.0000000"
        },
        "seo": {
          "browsertitle": "ME: OKC Couple Strangled Before Being Discovered In McIntosh Cou",
          "description": "As the search continues for the suspect in their murders, we are now learning more about the deaths of an Oklahoma City couple.",
          "pageurl": "me-okc-couple-strangled-before-being-discovered-in-mcintosh-county",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "McINTOSH COUNTY, Oklahoma"
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38329334/osbi-91-year-old-man-hospitalized-after-hulbert-home-invasion",
        "id": 38329334,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN05",
          "dateTime": "2018-06-01T17:01:04Z"
        },
        "headline": "OSBI: 91-Year-Old Man Hospitalized After Hulbert Home Invasion",
        "abstract": "<p>The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "OSBI: 91-Year-Old Man Hospitalized After Hulbert Home Invasion",
          "isclickable": true,
          "abstract": "<p>The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16892926_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T17:00:51.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16892926_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T17:00:51.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T21:01:03Z",
        "lastEditedDate": "2018-06-01T21:01:03Z",
        "publishedDate": "2018-06-01T21:01:03Z",
        "updatedDate": "2018-06-01T21:01:03Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T17:01:03.0000000",
          "lastedited": "2018-06-01T17:01:03.0000000",
          "published": "2018-06-01T17:01:03.0000000",
          "updated": "2018-06-01T17:01:03.0000000"
        },
        "seo": {
          "description": "The Oklahoma State Bureau of Investigation said a home invasion in Cherokee County ended with an elderly man in the hospital.",
          "pageurl": "osbi-91-year-old-man-hospitalized-after-hulbert-home-invasion",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "HULBERT, Oklahoma"
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38325736/okmulgee-county-jail-escapee-sought",
        "id": 38325736,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS18",
          "dateTime": "2018-06-01T15:08:54Z"
        },
        "headline": "Rape Suspect Escapes From Okmulgee County Jail",
        "abstract": "<p>Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.&nbsp;&nbsp;The sheriff's office says it not known if Coleman is armed, but he is&nbsp;considered to be dangerous.&nbsp;&nbsp; If seen, you are asked to call the sheriff's office at 918-756-0251.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Rape Suspect Escapes From Okmulgee County Jail",
          "isclickable": true,
          "abstract": "<p>Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.&nbsp;&nbsp;The sheriff's office says it not known if Coleman is armed, but he is&nbsp;considered to be dangerous.&nbsp;&nbsp; If seen, you are asked to call the sheriff's office at 918-756-0251.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16889690_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T09:44:12.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16889690_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T09:44:12.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T13:44:23Z",
        "lastEditedDate": "2018-06-01T19:04:30Z",
        "publishedDate": "2018-06-01T13:44:23Z",
        "updatedDate": "2018-06-01T19:04:30Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T09:44:23.0000000",
          "lastedited": "2018-06-01T15:04:30.0000000",
          "published": "2018-06-01T09:44:23.0000000",
          "updated": "2018-06-01T15:04:30.0000000"
        },
        "seo": {
          "description": "Okmulgee authorities are searching for a Okmulgee County jail escapee this morning. Deputies say 19-year-old Cayman Coleman escaped at around 6:30 a.m.  The sheriff's office says it not known if C...",
          "pageurl": "okmulgee-county-jail-escapee-sought",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "OKMULGEE, Oklahoma"
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38326249/police-identify-sand-springs-homicide-victim",
        "id": 38326249,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS09",
          "dateTime": "2018-06-01T13:14:42Z"
        },
        "headline": "Police Identify Sand Springs Homicide Victim",
        "abstract": "<p>Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.&nbsp;&nbsp;</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Police Identify Sand Springs Homicide Victim",
          "isclickable": true,
          "abstract": "<p>Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.&nbsp;&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16890203_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T10:47:48.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16890203_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T10:47:48.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T14:49:15Z",
        "lastEditedDate": "2018-06-01T17:07:48Z",
        "publishedDate": "2018-06-01T14:49:15Z",
        "updatedDate": "2018-06-01T17:07:48Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T10:49:15.0000000",
          "lastedited": "2018-06-01T13:07:48.0000000",
          "published": "2018-06-01T10:49:15.0000000",
          "updated": "2018-06-01T13:07:48.0000000"
        },
        "seo": {
          "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, Crime",
          "description": "Police have identified the victim of Thursday's homicide in Sand Springs as 73-year-old Patricia Louise Duff.  ",
          "pageurl": "police-identify-sand-springs-homicide-victim",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "SAND SPRINGS, Oklahoma",
        "topics": [{
          "type": "topic",
          "value": "Crime"
        }]
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38326746/overnight-search-leads-to-drug-bust-in-cherokee-county-kansas",
        "id": 38326746,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-06-01T11:48:26Z"
        },
        "headline": "Overnight Search Leads To Drug Bust In Cherokee County, Kansas",
        "abstract": "<p>A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night.&nbsp;</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Overnight Search Leads To Drug Bust In Cherokee County, Kansas",
          "isclickable": true,
          "abstract": "<p>A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night.&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16890668_G.jpg",
            "width": 115,
            "location": "LEFT",
            "caption": "Mug shot of Jeremey Manders.",
            "lastediteddate": "2018-06-01T11:45:15.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16890668_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T11:45:15.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T15:48:25Z",
        "lastEditedDate": "2018-06-01T15:48:25Z",
        "publishedDate": "2018-06-01T15:48:25Z",
        "updatedDate": "2018-06-01T15:48:25Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T11:48:25.0000000",
          "lastedited": "2018-06-01T11:48:25.0000000",
          "published": "2018-06-01T11:48:25.0000000",
          "updated": "2018-06-01T11:48:25.0000000"
        },
        "seo": {
          "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, Crime",
          "description": "A Cherokee County man is in jail after law enforcement executed a search warrant on his Crestline home late Thursday night. ",
          "pageurl": "overnight-search-leads-to-drug-bust-in-cherokee-county-kansas",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "CHEROKEE COUNTY, Kansas",
        "topics": [{
          "type": "topic",
          "value": "Crime"
        }]
      }, {
        "displaysize": "-20",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38324174/police-two-arrested-at-tulsa-quiktrip-on-kidnapping-robbery-complaints",
        "id": 38324174,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS09",
          "dateTime": "2018-06-01T09:09:34Z"
        },
        "headline": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
        "abstract": "<p>Police arrest two men Thursday evening after officers say the pair held and robbed another&nbsp;man in his own car outside a Tulsa QuikTrip.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
          "isclickable": true,
          "abstract": "<p>Police arrest two men Thursday evening after officers say the pair held and robbed another&nbsp;man in his own car outside a Tulsa QuikTrip.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16889094_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T08:16:33.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16889094_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-06-01T08:16:33.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T09:42:46Z",
        "lastEditedDate": "2018-06-01T13:01:31Z",
        "publishedDate": "2018-06-01T10:02:19Z",
        "updatedDate": "2018-06-01T13:01:31Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T05:42:46.0000000",
          "lastedited": "2018-06-01T09:01:31.0000000",
          "published": "2018-06-01T06:02:19.0000000",
          "updated": "2018-06-01T09:01:31.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 14390450,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-06-01T10:04:23.130Z"
        }],
        "seo": {
          "browsertitle": "Police Arrest Two On Robbery Complaints Outside A Tulsa QuikTrip",
          "description": "Police arrest two men Thursday evening after officers say the pair held and robbed another man in his own car outside a Tulsa QuikTrip.",
          "pageurl": "police-two-arrested-at-tulsa-quiktrip-on-kidnapping-robbery-complaints",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "TULSA, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38323745/sand-springs-man-arrested-on-first-degree-murder-complaint",
        "id": 38323745,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "IIS19",
          "dateTime": "2018-06-01T04:11:41Z"
        },
        "headline": "Sand Springs Man Arrested On First-Degree Murder Complaint",
        "abstract": "<p>A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Sand Springs Man Arrested On First-Degree Murder Complaint",
          "isclickable": true,
          "abstract": "<p>A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16887801_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-06-01T03:24:57.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16887801_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "Tulsa County jail photo of Darius Hatfield",
          "lastediteddate": "2018-06-01T03:24:57.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T07:25:13Z",
        "lastEditedDate": "2018-06-01T08:05:26Z",
        "publishedDate": "2018-06-01T07:25:13Z",
        "updatedDate": "2018-06-01T08:05:26Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-06-01T03:25:13.0000000",
          "lastedited": "2018-06-01T04:05:26.0000000",
          "published": "2018-06-01T03:25:13.0000000",
          "updated": "2018-06-01T04:05:26.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 14390397,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-06-01T08:07:17.670Z"
        }],
        "seo": {
          "description": "A Sand Springs man is booked into the Tulsa County jail on a first-degree murder complaint Thursday following a shooting a Tulsa County home.",
          "pageurl": "sand-springs-man-arrested-on-first-degree-murder-complaint",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "TULSA COUNTY, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38317461/okc-police-investigate-toddlers-death",
        "id": 38317461,
        "status": "Live",
        "owner": {
          "id": 690,
          "name": "KWTV",
          "baseurl": "www.news9.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-05-31T23:35:16Z"
        },
        "headline": "OKC Police Investigate Toddler's Death",
        "abstract": "<p>A 3-year-old girl has died from&nbsp;injuries suffered from abuse, Oklahoma City police said.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "OKC Police Investigate Toddler's Death",
          "isclickable": true,
          "abstract": "<p>A 3-year-old girl has died from&nbsp;injuries suffered from abuse, Oklahoma City police said.</p>",
          "abstractimage": {
            "filename": "http://KWTV.images.worldnow.com/images/16886652_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-05-31T22:32:46.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KWTV.images.worldnow.com/images/16886652_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-05-31T22:32:46.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T15:11:44Z",
        "lastEditedDate": "2018-06-01T03:35:16Z",
        "publishedDate": "2018-05-31T15:11:44Z",
        "updatedDate": "2018-06-01T03:34:14Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T11:11:44.0000000",
          "lastedited": "2018-05-31T23:35:16.0000000",
          "published": "2018-05-31T11:11:44.0000000",
          "updated": "2018-05-31T23:34:14.0000000"
        },
        "seo": {
          "keywords": "oklahoma city,okc,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,channel 9,channel nine,news 9,television,this morning,live radar,kwtv,Child Abuse, murder, Homicide, death",
          "description": "A 3-year-old girl has died from injuries suffered from abuse, Oklahoma City police said.",
          "pageurl": "okc-police-investigate-toddlers-death",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By",
          "firstname": "LeighAnne",
          "lastname": "Manwarren",
          "title": "News9.com",
          "emailaddress": "ryan.welton@news9.net"
        }],
        "dateline": "OKLAHOMA CITY",
        "topics": [{
          "type": "topic",
          "value": "Child Abuse"
        }, {
          "type": "topic",
          "value": "murder"
        }, {
          "type": "topic",
          "value": "Homicide"
        }, {
          "type": "topic",
          "value": "death"
        }]
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38322474/police-search-for-man-accused-in-mothers-brutal-attack",
        "id": 38322474,
        "status": "Live",
        "owner": {
          "id": 690,
          "name": "KWTV",
          "baseurl": "www.news9.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-06-01T10:17:07Z"
        },
        "headline": "Police Search For Man Accused In Mother’s Brutal Attack",
        "abstract": "<p>David Nelson had been staying with his mother at her apartment complex in a busy part of Moore.&nbsp;</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Police Search For Man Accused In Mother’s Brutal Attack",
          "isclickable": true,
          "abstract": "<p>David Nelson had been staying with his mother at her apartment complex in a busy part of Moore.&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KWTV.images.worldnow.com/images/16886529_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-05-31T22:04:30.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KWTV.images.worldnow.com/images/16886529_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-05-31T22:04:30.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-06-01T01:36:36Z",
        "lastEditedDate": "2018-06-01T02:11:00Z",
        "publishedDate": "2018-06-01T01:36:36Z",
        "updatedDate": "2018-06-01T02:11:00Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T21:36:36.0000000",
          "lastedited": "2018-05-31T22:11:00.0000000",
          "published": "2018-05-31T21:36:36.0000000",
          "updated": "2018-05-31T22:11:00.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 14390061,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-06-01T03:46:00.230Z"
        }, {
          "type": "Clip",
          "id": 14390836,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-06-01T14:17:07.453Z"
        }],
        "seo": {
          "description": "David Nelson had been staying with his mother at her apartment complex in a busy part of Moore. ",
          "pageurl": "police-search-for-man-accused-in-mothers-brutal-attack",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By",
          "firstname": "Christy",
          "lastname": "Lewis",
          "title": "News 9",
          "link": "/story/26668431/christy-lewis",
          "emailaddress": "ryan.welton@news9.net",
          "socialnetworksinfo": {
            "facebookpage": "https://www.facebook.com/ChristyLewisNews9",
            "twitter": "LewisChristy"
          }
        }],
        "dateline": "MOORE, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38320949/muskogee-police-searching-for-armed-robbery-suspect",
        "id": 38320949,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN01",
          "dateTime": "2018-05-31T19:52:54Z"
        },
        "headline": "Muskogee Police Searching For Armed Robbery Suspect",
        "abstract": "<p>Muskogee police are asking for help to solve an armed robbery caught on camera.</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Muskogee Police Searching For Armed Robbery Suspect",
          "isclickable": true,
          "abstract": "<p>Muskogee police are asking for help to solve an armed robbery caught on camera.</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16884234_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-05-31T17:14:19.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16884234_G.jpg",
          "width": 250,
          "location": "LEFT",
          "lastediteddate": "2018-05-31T17:14:19.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T21:19:43Z",
        "lastEditedDate": "2018-05-31T23:34:47Z",
        "publishedDate": "2018-05-31T21:19:43Z",
        "updatedDate": "2018-05-31T23:34:47Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T17:19:43.0000000",
          "lastedited": "2018-05-31T19:34:47.0000000",
          "published": "2018-05-31T17:19:43.0000000",
          "updated": "2018-05-31T19:34:47.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 14389326,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-05-31T23:52:54.913Z"
        }],
        "seo": {
          "description": "Muskogee police are asking for help to solve an armed robbery caught on camera.",
          "pageurl": "muskogee-police-searching-for-armed-robbery-suspect",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }],
        "dateline": "MUSKOGEE, Oklahoma"
      }, {
        "displaysize": "-18",
        "displayorder": "1",
        "isimplicit": false,
        "type": "story",
        "link": "http://www.newson6.com/story/38319308/federal-charge-for-man-accused-of-forcing-flight-diversion-to-tulsa",
        "id": 38319308,
        "status": "Live",
        "owner": {
          "id": 691,
          "name": "KOTV",
          "baseurl": "www.newson6.com",
          "enablecommentsonshare": false
        },
        "build": {
          "machinename": "NJTASKRUN04",
          "dateTime": "2018-05-31T19:55:02Z"
        },
        "headline": "Federal Charge For Man Accused Of Forcing Flight Diversion To Tulsa",
        "abstract": "<p>Federal prosecutors filed a single charge against the man accused of causing a disturbance on a Delta flight that caused it to divert to Tulsa on Wednesday.&nbsp;</p>",
        "contentClassification": "Crime",
        "cls": 566,
        "abridged": {
          "headline": "Federal Charge For Man Accused Of Forcing Flight Diversion To Tulsa",
          "isclickable": true,
          "abstract": "<p>Federal prosecutors filed a single charge against the man accused of causing a disturbance on a Delta flight that caused it to divert to Tulsa on Wednesday.&nbsp;</p>",
          "abstractimage": {
            "filename": "http://KOTV.images.worldnow.com/images/16883000_G.jpg",
            "width": 115,
            "location": "LEFT",
            "lastediteddate": "2018-05-31T14:20:12.0000000"
          }
        },
        "abstractimage": {
          "filename": "http://KOTV.images.worldnow.com/images/16883000_G.jpg",
          "width": 250,
          "location": "LEFT",
          "caption": "Photo of Bolutifee Olorunda being escorted off the flight by Tulsa Police.",
          "lastediteddate": "2018-05-31T14:20:12.0000000"
        },
        "options": {
          "date": {
            "creation": {
              "showonstory": true
            },
            "lastedited": {
              "showonstory": true,
              "showonabstract": false
            },
            "published": {
              "showonstory": true,
              "showonabstract": true
            },
            "updated": {
              "showonstory": true,
              "showonabstract": false
            }
          },
          "socialtools": {
            "comments": {
              "display": false
            },
            "ratings": {
              "display": false
            }
          }
        },
        "creationDate": "2018-05-31T18:21:52Z",
        "lastEditedDate": "2018-05-31T23:14:59Z",
        "publishedDate": "2018-05-31T18:21:52Z",
        "updatedDate": "2018-05-31T23:14:59Z",
        "sortbydatetype": "LastEdited",
        "datetime": {
          "created": "2018-05-31T14:21:52.0000000",
          "lastedited": "2018-05-31T19:14:59.0000000",
          "published": "2018-05-31T14:21:52.0000000",
          "updated": "2018-05-31T19:14:59.0000000"
        },
        "surfaceable": [{
          "type": "Clip",
          "id": 14389439,
          "status": "L",
          "displaysize": 37,
          "displayorder": 1,
          "sortbydate": "2018-05-31T23:55:02.010Z"
        }],
        "seo": {
          "browsertitle": "Federal Charge For Man Accused Of Forcing Flight Diversion To Tu",
          "keywords": "tulsa,media,news,weather,tv,cbs,local,tornado,storm,oklahoma,kotv.com,channel 6,channel six,green country,television,the news on 6,the news on six,six in the morning,live, aviation",
          "description": "Federal prosecutors filed a single charge against the man accused of causing a disturbance on a Delta flight that caused it to divert to Tulsa on Wednesday. ",
          "pageurl": "federal-charge-for-man-accused-of-forcing-flight-diversion-to-tulsa",
          "includedate": false
        },
        "bylines": [{
          "type": "byline",
          "prefix": "By:",
          "firstname": "NewsOn6.com",
          "emailaddress": "richard.clark@newson6.net"
        }, {
          "type": "byline",
          "prefix": "By:",
          "firstname": "Justin",
          "lastname": "Shrair",
          "title": "News On 6",
          "link": "/story/35351751/justin-shrair",
          "emailaddress": "richard.clark@newson6.net",
          "socialnetworksinfo": {
            "facebookpage": "https://www.facebook.com/JustinShrairNewsOn6/",
            "twitter": "justinshrair"
          }
        }],
        "dateline": "TULSA, Oklahoma",
        "topics": [{
          "type": "topic",
          "value": "aviation"
        }]
      }],
      "totalresults": 11
    }
  }, {
    "displaysize": "120",
    "displayorder": "5",
    "isimplicit": false,
    "type": "menu",
    "id": 682,
    "status": "Live",
    "style": 2,
    "depth": 2,
    "istext": false,
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T17:19:01Z"
    },
    "items": [{
      "name": "menu682_1",
      "id": 112039,
      "type": "category",
      "link": "http://www.newson6.com/",
      "pageurl": "home",
      "lastEditedDate": "2018-06-01T21:19:00Z",
      "creationDate": "2007-09-20T20:22:32Z",
      "headline": "Oklahoma's Own News On 6",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394510_G.gif",
        "width": 15,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394509_G.gif",
        "width": 15,
        "height": 39
      },
      "position": 1
    }, {
      "name": "menu682_2",
      "id": 112042,
      "type": "category",
      "link": "http://www.newson6.com/category/112042/news",
      "pageurl": "news",
      "lastEditedDate": "2013-12-18T15:51:36Z",
      "creationDate": "2007-09-20T20:22:32Z",
      "headline": "News",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394512_G.gif",
        "width": 38,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394511_G.gif",
        "width": 38,
        "height": 39
      },
      "position": 2,
      "menu": {
        "items": [{
          "name": "menu682_2_1",
          "id": 120892,
          "type": "category",
          "link": "http://www.newson6.com/category/120892/special-coverage",
          "pageurl": "special-coverage",
          "lastEditedDate": "2014-08-27T20:52:43Z",
          "creationDate": "2007-12-29T16:53:23Z",
          "headline": "Special Coverage",
          "text": "",
          "position": 5
        }, {
          "name": "menu682_2_2",
          "id": 121090,
          "type": "category",
          "link": "http://www.newson6.com/category/121090/the-news-on-6-news-tips",
          "pageurl": "the-news-on-6-news-tips",
          "lastEditedDate": "2015-03-16T15:40:23Z",
          "creationDate": "2007-12-31T17:38:13Z",
          "headline": "Send Us News Tips",
          "text": "",
          "position": 5
        }, {
          "name": "menu682_2_3",
          "id": 494144,
          "type": "link",
          "link": "http://www.newson6.com/link/494144/health",
          "pageurl": "health",
          "lastEditedDate": "2011-06-15T15:38:42Z",
          "creationDate": "2011-06-15T15:38:42Z",
          "headline": "Health",
          "text": "",
          "url": "/category/38921/health",
          "window": {
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 8
        }, {
          "name": "menu682_2_4",
          "id": 494145,
          "type": "link",
          "link": "http://www.newson6.com/link/494145/strange-news",
          "pageurl": "strange-news",
          "lastEditedDate": "2011-06-15T15:39:42Z",
          "creationDate": "2011-06-15T15:39:42Z",
          "headline": "Strange News",
          "text": "",
          "url": "/category/13544/strange-news",
          "window": {
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 9
        }, {
          "name": "menu682_2_5",
          "id": 138127,
          "type": "category",
          "link": "http://www.newson6.com/category/138127/direct-email-promo-page",
          "pageurl": "direct-email-promo-page",
          "lastEditedDate": "2015-12-29T20:28:37Z",
          "creationDate": "2008-05-27T22:28:36Z",
          "headline": "Email Sign-Up",
          "text": "",
          "position": 11
        }, {
          "name": "menu682_2_6",
          "id": 175087,
          "type": "category",
          "link": "http://www.newson6.com/category/175087/6-investigates",
          "pageurl": "6-investigates",
          "lastEditedDate": "2013-01-31T19:45:06Z",
          "creationDate": "2009-09-16T20:03:24Z",
          "headline": "6 Investigates",
          "text": "",
          "position": 3
        }, {
          "name": "menu682_2_7",
          "id": 161867,
          "type": "category",
          "link": "http://www.newson6.com/category/161867/crime",
          "pageurl": "crime",
          "lastEditedDate": "2016-03-29T19:44:31Z",
          "creationDate": "2009-03-02T16:15:57Z",
          "headline": "Crime",
          "text": "",
          "position": 4
        }]
      }
    }, {
      "name": "menu682_3",
      "id": 112040,
      "type": "category",
      "link": "http://www.newson6.com/weather",
      "pageurl": "weather",
      "lastEditedDate": "2015-02-27T15:54:29Z",
      "creationDate": "2007-09-20T20:22:32Z",
      "headline": "Weather",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394514_G.gif",
        "width": 65,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394513_G.gif",
        "width": 65,
        "height": 39
      },
      "position": 3
    }, {
      "name": "menu682_4",
      "id": 121535,
      "type": "category",
      "link": "http://www.newson6.com/video",
      "pageurl": "video-page",
      "lastEditedDate": "2017-06-16T18:15:47Z",
      "creationDate": "2008-01-07T15:56:04Z",
      "headline": "Video",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394516_G.gif",
        "width": 40,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394515_G.gif",
        "width": 40,
        "height": 39
      },
      "position": 4
    }, {
      "name": "menu682_5",
      "id": 112043,
      "type": "category",
      "link": "http://www.newson6.com/category/112043/sports",
      "pageurl": "sports",
      "lastEditedDate": "2012-06-01T21:13:08Z",
      "creationDate": "2007-09-20T20:22:32Z",
      "headline": "Sports",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394518_G.gif",
        "width": 53,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394517_G.gif",
        "width": 53,
        "height": 39
      },
      "position": 5
    }, {
      "name": "menu682_6",
      "id": 301885,
      "type": "link",
      "link": "http://www.newson6.com/link/301885/share",
      "pageurl": "share",
      "lastEditedDate": "2012-06-01T21:14:27Z",
      "creationDate": "2008-03-05T20:50:09Z",
      "headline": "Share",
      "text": "",
      "url": "http://pics.newson6.com",
      "window": {
        "title": "YouNewsTV",
        "showlocation": false,
        "showscrollbar": false,
        "showtoolbar": false,
        "isresizable": false,
        "isnewwindow": false
      },
      "layout": 3,
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394520_G.gif",
        "width": 45,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394519_G.gif",
        "width": 45,
        "height": 39
      },
      "position": 6
    }, {
      "name": "menu682_7",
      "id": 116530,
      "type": "category",
      "link": "http://www.newson6.com/category/116530/recipes",
      "pageurl": "recipes",
      "lastEditedDate": "2014-01-02T21:41:39Z",
      "creationDate": "2007-11-12T22:04:27Z",
      "headline": "Recipes",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394522_G.gif",
        "width": 56,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394521_G.gif",
        "width": 56,
        "height": 39
      },
      "position": 7,
      "menu": {
        "items": [{
          "name": "menu682_7_1",
          "id": 34616914,
          "type": "story",
          "link": "http://www.newson6.com/story/34616914/spinach-and-rice-stuffed-bell-peppers",
          "pageurl": "spinach-and-rice-stuffed-bell-peppers",
          "includedate": false,
          "lastEditedDate": "2017-02-27T21:23:21Z",
          "creationDate": "2017-02-27T21:23:22Z",
          "headline": "Spinach And Rice Stuffed Bell Peppers",
          "text": "",
          "position": 1
        }, {
          "name": "menu682_7_2",
          "id": 370156,
          "type": "link",
          "link": "http://www.newson6.com/link/370156/latest-recipes",
          "pageurl": "latest-recipes",
          "lastEditedDate": "2011-06-16T19:58:59Z",
          "creationDate": "2009-02-06T15:04:51Z",
          "headline": "Latest Recipes",
          "text": "",
          "url": "/category/116530/recipes",
          "window": {
            "title": "Recipes",
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 1
        }, {
          "name": "menu682_7_3",
          "id": 213791,
          "type": "category",
          "link": "http://www.newson6.com/category/213791/recipe-by-type",
          "pageurl": "recipe-by-type",
          "lastEditedDate": "2013-07-25T14:31:28Z",
          "creationDate": "2011-06-15T14:53:15Z",
          "headline": "By Type",
          "text": "",
          "position": 2
        }, {
          "name": "menu682_7_4",
          "id": 213792,
          "type": "category",
          "link": "http://www.newson6.com/category/213792/recipes-by-specialty",
          "pageurl": "recipes-by-specialty",
          "lastEditedDate": "2013-07-25T14:31:01Z",
          "creationDate": "2011-06-15T14:54:02Z",
          "headline": "By Specialty",
          "text": "",
          "position": 3
        }, {
          "name": "menu682_7_5",
          "id": 370130,
          "type": "link",
          "link": "http://www.newson6.com/link/370130/sign-up-for-recipe-emails",
          "pageurl": "sign-up-for-recipe-emails",
          "lastEditedDate": "2011-06-30T16:13:26Z",
          "creationDate": "2009-02-06T12:01:17Z",
          "headline": "Sign Up For Recipe Emails",
          "text": "",
          "url": "/category/138127/direct-email-promo-page",
          "window": {
            "title": "Sign Up For Recipe Emails",
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 5
        }]
      }
    }, {
      "name": "menu682_8",
      "id": 68446,
      "type": "category",
      "link": "http://www.newson6.com/category/68446/lifestyle",
      "pageurl": "lifestyle",
      "lastEditedDate": "2015-04-29T18:32:24Z",
      "creationDate": "2005-08-04T18:10:50Z",
      "headline": "LIFESTYLE",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394524_G.gif",
        "width": 69,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394523_G.gif",
        "width": 69,
        "height": 39
      },
      "position": 8,
      "locked": true,
      "menu": {
        "items": [{
          "name": "menu682_8_1",
          "id": 73801,
          "type": "category",
          "link": "http://www.newson6.com/category/73801/entertainment",
          "pageurl": "entertainment",
          "lastEditedDate": "2016-01-07T20:26:52Z",
          "creationDate": "2005-12-07T23:28:50Z",
          "headline": "Entertainment",
          "text": "",
          "position": 5
        }, {
          "name": "menu682_8_2",
          "id": 120652,
          "type": "category",
          "link": "http://www.newson6.com/category/120652/money",
          "pageurl": "money",
          "lastEditedDate": "2016-01-07T20:26:08Z",
          "creationDate": "2007-12-27T16:00:42Z",
          "headline": "Money",
          "text": "",
          "position": 6
        }, {
          "name": "menu682_8_3",
          "id": 120651,
          "type": "category",
          "link": "http://www.newson6.com/category/120651/home-family",
          "pageurl": "home-family",
          "lastEditedDate": "2016-01-07T20:27:39Z",
          "creationDate": "2007-12-27T15:59:25Z",
          "headline": "Home/Family",
          "text": "",
          "position": 7
        }, {
          "name": "menu682_8_4",
          "id": 38921,
          "type": "category",
          "link": "http://www.newson6.com/category/38921/health",
          "pageurl": "health",
          "lastEditedDate": "2016-01-07T20:28:16Z",
          "creationDate": "2003-03-17T19:19:09Z",
          "headline": "Health",
          "text": "",
          "position": 8
        }, {
          "name": "menu682_8_5",
          "id": 39546,
          "type": "category",
          "link": "http://www.newson6.com/category/39546/food",
          "pageurl": "food",
          "lastEditedDate": "2016-01-07T20:29:08Z",
          "creationDate": "2003-03-27T15:59:20Z",
          "headline": "Food",
          "text": "",
          "position": 9,
          "locked": true
        }, {
          "name": "menu682_8_6",
          "id": 29878,
          "type": "category",
          "link": "http://www.newson6.com/category/29878/pets",
          "pageurl": "pets",
          "lastEditedDate": "2016-01-07T20:31:34Z",
          "creationDate": "2002-07-16T22:20:30Z",
          "headline": "Pets",
          "text": "",
          "position": 10
        }, {
          "name": "menu682_8_7",
          "id": 58532,
          "type": "category",
          "link": "http://www.newson6.com/category/58532/technology",
          "pageurl": "technology",
          "lastEditedDate": "2016-01-07T20:54:01Z",
          "creationDate": "2004-10-05T20:39:28Z",
          "headline": "Tech",
          "text": "",
          "position": 11
        }, {
          "name": "menu682_8_8",
          "id": 23748,
          "type": "category",
          "link": "http://www.newson6.com/category/23748/travel",
          "pageurl": "travel",
          "lastEditedDate": "2016-01-07T20:54:37Z",
          "creationDate": "2002-01-24T18:07:35Z",
          "headline": "Travel",
          "text": "",
          "position": 12,
          "locked": true
        }, {
          "name": "menu682_8_9",
          "id": 76708,
          "type": "category",
          "link": "http://www.newson6.com/category/76708/beauty-style",
          "pageurl": "beauty-style",
          "lastEditedDate": "2016-01-07T20:55:48Z",
          "creationDate": "2006-02-22T18:02:27Z",
          "headline": "Beauty & Style",
          "text": "",
          "position": 13
        }, {
          "name": "menu682_8_10",
          "id": 41934,
          "type": "category",
          "link": "http://www.newson6.com/category/41934/auto",
          "pageurl": "auto",
          "lastEditedDate": "2016-01-07T20:56:24Z",
          "creationDate": "2003-05-29T14:28:57Z",
          "headline": "Auto",
          "text": "",
          "position": 14
        }, {
          "name": "menu682_8_11",
          "id": 120657,
          "type": "category",
          "link": "http://www.newson6.com/category/120657/videobytes",
          "pageurl": "videobytes",
          "lastEditedDate": "2016-01-07T20:58:17Z",
          "creationDate": "2007-12-27T16:04:12Z",
          "headline": "VideoBytes",
          "text": "",
          "position": 99
        }, {
          "name": "menu682_8_12",
          "id": 230909,
          "type": "category",
          "link": "http://www.newson6.com/category/230909/press-releases",
          "pageurl": "press-releases",
          "lastEditedDate": "2016-01-08T17:10:36Z",
          "creationDate": "2012-01-31T22:46:30Z",
          "headline": "Press Releases",
          "text": "",
          "position": 100
        }, {
          "name": "menu682_8_13",
          "id": 192776,
          "type": "link",
          "link": "http://www.newson6.com/link/192776/lifestyle-home",
          "pageurl": "lifestyle-home",
          "lastEditedDate": "2012-09-27T16:14:34Z",
          "creationDate": "2006-05-19T21:08:59Z",
          "headline": "Main",
          "text": "",
          "url": "/category/124895/lifestyle",
          "window": {
            "title": "Lifestyle Home",
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 1
        }]
      }
    }, {
      "name": "menu682_9",
      "id": 122577,
      "type": "category",
      "link": "http://www.newson6.com/category/122577/contests",
      "pageurl": "contests",
      "lastEditedDate": "2011-04-25T20:06:13Z",
      "creationDate": "2008-01-16T16:53:37Z",
      "headline": "Contests",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394528_G.gif",
        "width": 70,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394527_G.gif",
        "width": 70,
        "height": 39
      },
      "position": 9,
      "menu": {
        "item": {
          "name": "menu682_9_1",
          "id": 462221,
          "type": "link",
          "link": "http://www.newson6.com/link/462221/text-win",
          "pageurl": "text-win",
          "lastEditedDate": "2013-09-10T18:01:26Z",
          "creationDate": "2010-10-21T19:28:13Z",
          "headline": "Text & Win",
          "text": "",
          "url": "/category/176087/text-win-landing",
          "window": {
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 10
        }
      }
    }, {
      "name": "menu682_10",
      "id": 197945,
      "type": "category",
      "link": "http://www.newson6.com/category/197945/community",
      "pageurl": "community",
      "lastEditedDate": "2011-03-09T16:34:37Z",
      "creationDate": "2010-10-15T12:15:45Z",
      "headline": "Community",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394530_G.gif",
        "width": 80,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394529_G.gif",
        "width": 80,
        "height": 39
      },
      "position": 10,
      "menu": {
        "item": {
          "name": "menu682_10_1",
          "id": 138127,
          "type": "category",
          "link": "http://www.newson6.com/category/138127/direct-email-promo-page",
          "pageurl": "direct-email-promo-page",
          "lastEditedDate": "2015-12-29T20:28:37Z",
          "creationDate": "2008-05-27T22:28:36Z",
          "headline": "Email Sign-Up",
          "text": "",
          "position": 20
        }
      }
    }, {
      "name": "menu682_11",
      "id": 156589,
      "type": "category",
      "link": "http://www.newson6.com/category/156589/about-us",
      "pageurl": "about-us",
      "lastEditedDate": "2016-01-15T19:48:31Z",
      "creationDate": "2008-12-30T17:01:26Z",
      "headline": "Contact Us",
      "text": "",
      "onimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394532_G.gif",
        "width": 83,
        "height": 39
      },
      "offimage": {
        "filename": "http://KOTV.images.worldnow.com/images/394531_G.gif",
        "width": 83,
        "height": 39
      },
      "position": 11
    }]
  }, {
    "displaysize": "121",
    "displayorder": "5",
    "isimplicit": false,
    "type": "menu",
    "id": 1299,
    "status": "Live",
    "style": 2,
    "depth": 2,
    "istext": false,
    "build": {
      "machinename": "NJTASKRUN05",
      "dateTime": "2018-06-01T17:19:01Z"
    },
    "items": [{
      "name": "menu1299_1",
      "id": 112042,
      "type": "category",
      "link": "http://www.newson6.com/category/112042/news",
      "pageurl": "news",
      "lastEditedDate": "2013-12-18T15:51:36Z",
      "creationDate": "2007-09-20T20:22:32Z",
      "headline": "News",
      "text": "",
      "position": 1,
      "menu": {
        "items": [{
          "name": "menu1299_1_1",
          "id": 120892,
          "type": "category",
          "link": "http://www.newson6.com/category/120892/special-coverage",
          "pageurl": "special-coverage",
          "lastEditedDate": "2014-08-27T20:52:43Z",
          "creationDate": "2007-12-29T16:53:23Z",
          "headline": "Special Coverage",
          "text": "",
          "position": 5
        }, {
          "name": "menu1299_1_2",
          "id": 121090,
          "type": "category",
          "link": "http://www.newson6.com/category/121090/the-news-on-6-news-tips",
          "pageurl": "the-news-on-6-news-tips",
          "lastEditedDate": "2015-03-16T15:40:23Z",
          "creationDate": "2007-12-31T17:38:13Z",
          "headline": "Send Us News Tips",
          "text": "",
          "position": 5
        }, {
          "name": "menu1299_1_3",
          "id": 494144,
          "type": "link",
          "link": "http://www.newson6.com/link/494144/health",
          "pageurl": "health",
          "lastEditedDate": "2011-06-15T15:38:42Z",
          "creationDate": "2011-06-15T15:38:42Z",
          "headline": "Health",
          "text": "",
          "url": "/category/38921/health",
          "window": {
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 8
        }, {
          "name": "menu1299_1_4",
          "id": 494145,
          "type": "link",
          "link": "http://www.newson6.com/link/494145/strange-news",
          "pageurl": "strange-news",
          "lastEditedDate": "2011-06-15T15:39:42Z",
          "creationDate": "2011-06-15T15:39:42Z",
          "headline": "Strange News",
          "text": "",
          "url": "/category/13544/strange-news",
          "window": {
            "showlocation": false,
            "showscrollbar": false,
            "showtoolbar": false,
            "isresizable": false,
            "isnewwindow": false
          },
          "layout": 3,
          "position": 9
        }, {
          "name": "menu1299_1_5",
          "id": 138127,
          "type": "category",
          "link": "http://www.newson6.com/category/138127/direct-email-promo-page",
          "pageurl": "direct-email-promo-page",
          "lastEditedDate": "2015-12-29T20:28:37Z",
          "creationDate": "2008-05-27T22:28:36Z",
          "headline": "Email Sign-Up",
          "text": "",
          "position": 11
        }, {
          "name": "menu1299_1_6",
          "id": 175087,
          "type": "category",
          "link": "http://www.newson6.com/category/175087/6-investigates",
          "pageurl": "6-investigates",
          "lastEditedDate": "2013-01-31T19:45:06Z",
          "creationDate": "2009-09-16T20:03:24Z",
          "headline": "6 Investigates",
          "text": "",
          "position": 3
        }, {
          "name": "menu1299_1_7",
          "id": 161867,
          "type": "category",
          "link": "http://www.newson6.com/category/161867/crime",
          "pageurl": "crime",
          "lastEditedDate": "2016-03-29T19:44:31Z",
          "creationDate": "2009-03-02T16:15:57Z",
          "headline": "Crime",
          "text": "",
          "position": 4
        }]
      }
    }, {
      "name": "menu1299_2",
      "id": 123096,
      "type": "category",
      "link": "http://www.newson6.com/category/123096/weather-forecast",
      "pageurl": "weather-forecast",
      "lastEditedDate": "2013-07-25T15:57:41Z",
      "creationDate": "2008-01-22T20:23:40Z",
      "headline": "Weather Forecast",
      "text": "",
      "position": 2
    }, {
      "name": "menu1299_3",
      "id": 120897,
      "type": "category",
      "link": "http://www.newson6.com/category/120897/the-news-on-6-featured-links",
      "pageurl": "the-news-on-6-featured-links",
      "lastEditedDate": "2010-10-24T18:34:37Z",
      "creationDate": "2007-12-29T17:07:18Z",
      "headline": "Links Mentioned",
      "text": "",
      "position": 7
    }, {
      "name": "menu1299_4",
      "id": 53065,
      "type": "category",
      "link": "http://www.newson6.com/category/53065/oklahoma-headlines",
      "pageurl": "oklahoma-headlines",
      "lastEditedDate": "2004-05-03T14:13:27Z",
      "creationDate": "2004-05-03T14:13:27Z",
      "headline": "Oklahoma Headlines",
      "text": "",
      "position": 8
    }]
  }],
  "version": "7.4.8.5"
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/category.js